//area平铺数据,文本映射code
export const AreaFlatReverse = {
	province_list: {
		北京市: '110000',
		天津市: '120000',
		河北省: '130000',
		山西省: '140000',
		内蒙古自治区: '150000',
		辽宁省: '210000',
		吉林省: '220000',
		黑龙江省: '230000',
		上海市: '310000',
		江苏省: '320000',
		浙江省: '330000',
		安徽省: '340000',
		福建省: '350000',
		江西省: '360000',
		山东省: '370000',
		河南省: '410000',
		湖北省: '420000',
		湖南省: '430000',
		广东省: '440000',
		广西壮族自治区: '450000',
		海南省: '460000',
		重庆市: '500000',
		四川省: '510000',
		贵州省: '520000',
		云南省: '530000',
		西藏自治区: '540000',
		陕西省: '610000',
		甘肃省: '620000',
		青海省: '630000',
		宁夏回族自治区: '640000',
		新疆维吾尔自治区: '650000',
		台湾省: '710000',
		香港特别行政区: '810000',
		澳门特别行政区: '820000',
		海外: '900000',
	},
	city_list: {
		北京市: '110100',
		天津市: '120100',
		石家庄市: '130100',
		唐山市: '130200',
		秦皇岛市: '130300',
		邯郸市: '130400',
		邢台市: '130500',
		保定市: '130600',
		张家口市: '130700',
		承德市: '130800',
		沧州市: '130900',
		廊坊市: '131000',
		衡水市: '131100',
		太原市: '140100',
		大同市: '140200',
		阳泉市: '140300',
		长治市: '140400',
		晋城市: '140500',
		朔州市: '140600',
		晋中市: '140700',
		运城市: '140800',
		忻州市: '140900',
		临汾市: '141000',
		吕梁市: '141100',
		呼和浩特市: '150100',
		包头市: '150200',
		乌海市: '150300',
		赤峰市: '150400',
		通辽市: '150500',
		鄂尔多斯市: '150600',
		呼伦贝尔市: '150700',
		巴彦淖尔市: '150800',
		乌兰察布市: '150900',
		兴安盟: '152200',
		锡林郭勒盟: '152500',
		阿拉善盟: '152900',
		沈阳市: '210100',
		大连市: '210200',
		鞍山市: '210300',
		抚顺市: '210400',
		本溪市: '210500',
		丹东市: '210600',
		锦州市: '210700',
		营口市: '210800',
		阜新市: '210900',
		辽阳市: '211000',
		盘锦市: '211100',
		铁岭市: '211200',
		朝阳市: '211300',
		葫芦岛市: '211400',
		长春市: '220100',
		吉林市: '220200',
		四平市: '220300',
		辽源市: '220400',
		通化市: '220500',
		白山市: '220600',
		松原市: '220700',
		白城市: '220800',
		延边朝鲜族自治州: '222400',
		哈尔滨市: '230100',
		齐齐哈尔市: '230200',
		鸡西市: '230300',
		鹤岗市: '230400',
		双鸭山市: '230500',
		大庆市: '230600',
		伊春市: '230700',
		佳木斯市: '230800',
		七台河市: '230900',
		牡丹江市: '231000',
		黑河市: '231100',
		绥化市: '231200',
		大兴安岭地区: '232700',
		上海市: '310100',
		南京市: '320100',
		无锡市: '320200',
		徐州市: '320300',
		常州市: '320400',
		苏州市: '320500',
		南通市: '320600',
		连云港市: '320700',
		淮安市: '320800',
		盐城市: '320900',
		扬州市: '321000',
		镇江市: '321100',
		泰州市: '321200',
		宿迁市: '321300',
		杭州市: '330100',
		宁波市: '330200',
		温州市: '330300',
		嘉兴市: '330400',
		湖州市: '330500',
		绍兴市: '330600',
		金华市: '330700',
		衢州市: '330800',
		舟山市: '330900',
		台州市: '331000',
		丽水市: '331100',
		合肥市: '340100',
		芜湖市: '340200',
		蚌埠市: '340300',
		淮南市: '340400',
		马鞍山市: '340500',
		淮北市: '340600',
		铜陵市: '340700',
		安庆市: '340800',
		黄山市: '341000',
		滁州市: '341100',
		阜阳市: '341200',
		宿州市: '341300',
		六安市: '341500',
		亳州市: '341600',
		池州市: '341700',
		宣城市: '341800',
		福州市: '350100',
		厦门市: '350200',
		莆田市: '350300',
		三明市: '350400',
		泉州市: '350500',
		漳州市: '350600',
		南平市: '350700',
		龙岩市: '350800',
		宁德市: '350900',
		南昌市: '360100',
		景德镇市: '360200',
		萍乡市: '360300',
		九江市: '360400',
		新余市: '360500',
		鹰潭市: '360600',
		赣州市: '360700',
		吉安市: '360800',
		宜春市: '360900',
		抚州市: '361000',
		上饶市: '361100',
		济南市: '370100',
		青岛市: '370200',
		淄博市: '370300',
		枣庄市: '370400',
		东营市: '370500',
		烟台市: '370600',
		潍坊市: '370700',
		济宁市: '370800',
		泰安市: '370900',
		威海市: '371000',
		日照市: '371100',
		临沂市: '371300',
		德州市: '371400',
		聊城市: '371500',
		滨州市: '371600',
		菏泽市: '371700',
		郑州市: '410100',
		开封市: '410200',
		洛阳市: '410300',
		平顶山市: '410400',
		安阳市: '410500',
		鹤壁市: '410600',
		新乡市: '410700',
		焦作市: '410800',
		濮阳市: '410900',
		许昌市: '411000',
		漯河市: '411100',
		三门峡市: '411200',
		南阳市: '411300',
		商丘市: '411400',
		信阳市: '411500',
		周口市: '411600',
		驻马店市: '411700',
		省直辖县: '469000',
		武汉市: '420100',
		黄石市: '420200',
		十堰市: '420300',
		宜昌市: '420500',
		襄阳市: '420600',
		鄂州市: '420700',
		荆门市: '420800',
		孝感市: '420900',
		荆州市: '421000',
		黄冈市: '421100',
		咸宁市: '421200',
		随州市: '421300',
		恩施土家族苗族自治州: '422800',
		长沙市: '430100',
		株洲市: '430200',
		湘潭市: '430300',
		衡阳市: '430400',
		邵阳市: '430500',
		岳阳市: '430600',
		常德市: '430700',
		张家界市: '430800',
		益阳市: '430900',
		郴州市: '431000',
		永州市: '431100',
		怀化市: '431200',
		娄底市: '431300',
		湘西土家族苗族自治州: '433100',
		广州市: '440100',
		韶关市: '440200',
		深圳市: '440300',
		珠海市: '440400',
		汕头市: '440500',
		佛山市: '440600',
		江门市: '440700',
		湛江市: '440800',
		茂名市: '440900',
		肇庆市: '441200',
		惠州市: '441300',
		梅州市: '441400',
		汕尾市: '441500',
		河源市: '441600',
		阳江市: '441700',
		清远市: '441800',
		东莞市: '441900',
		中山市: '442000',
		潮州市: '445100',
		揭阳市: '445200',
		云浮市: '445300',
		南宁市: '450100',
		柳州市: '450200',
		桂林市: '450300',
		梧州市: '450400',
		北海市: '450500',
		防城港市: '450600',
		钦州市: '450700',
		贵港市: '450800',
		玉林市: '450900',
		百色市: '451000',
		贺州市: '451100',
		河池市: '451200',
		来宾市: '451300',
		崇左市: '451400',
		海口市: '460100',
		三亚市: '460200',
		三沙市: '460300',
		儋州市: '460400',
		重庆市: '500100',
		县: '500200',
		成都市: '510100',
		自贡市: '510300',
		攀枝花市: '510400',
		泸州市: '510500',
		德阳市: '510600',
		绵阳市: '510700',
		广元市: '510800',
		遂宁市: '510900',
		内江市: '511000',
		乐山市: '511100',
		南充市: '511300',
		眉山市: '511400',
		宜宾市: '511500',
		广安市: '511600',
		达州市: '511700',
		雅安市: '511800',
		巴中市: '511900',
		资阳市: '512000',
		阿坝藏族羌族自治州: '513200',
		甘孜藏族自治州: '513300',
		凉山彝族自治州: '513400',
		贵阳市: '520100',
		六盘水市: '520200',
		遵义市: '520300',
		安顺市: '520400',
		毕节市: '520500',
		铜仁市: '520600',
		黔西南布依族苗族自治州: '522300',
		黔东南苗族侗族自治州: '522600',
		黔南布依族苗族自治州: '522700',
		昆明市: '530100',
		曲靖市: '530300',
		玉溪市: '530400',
		保山市: '530500',
		昭通市: '530600',
		丽江市: '530700',
		普洱市: '530800',
		临沧市: '530900',
		楚雄彝族自治州: '532300',
		红河哈尼族彝族自治州: '532500',
		文山壮族苗族自治州: '532600',
		西双版纳傣族自治州: '532800',
		大理白族自治州: '532900',
		德宏傣族景颇族自治州: '533100',
		怒江傈僳族自治州: '533300',
		迪庆藏族自治州: '533400',
		拉萨市: '540100',
		日喀则市: '540200',
		昌都市: '540300',
		林芝市: '540400',
		山南市: '540500',
		那曲市: '540600',
		阿里地区: '542500',
		西安市: '610100',
		铜川市: '610200',
		宝鸡市: '610300',
		咸阳市: '610400',
		渭南市: '610500',
		延安市: '610600',
		汉中市: '610700',
		榆林市: '610800',
		安康市: '610900',
		商洛市: '611000',
		兰州市: '620100',
		嘉峪关市: '620200',
		金昌市: '620300',
		白银市: '620400',
		天水市: '620500',
		武威市: '620600',
		张掖市: '620700',
		平凉市: '620800',
		酒泉市: '620900',
		庆阳市: '621000',
		定西市: '621100',
		陇南市: '621200',
		临夏回族自治州: '622900',
		甘南藏族自治州: '623000',
		西宁市: '630100',
		海东市: '630200',
		海北藏族自治州: '632200',
		黄南藏族自治州: '632300',
		海南藏族自治州: '632500',
		果洛藏族自治州: '632600',
		玉树藏族自治州: '632700',
		海西蒙古族藏族自治州: '632800',
		银川市: '640100',
		石嘴山市: '640200',
		吴忠市: '640300',
		固原市: '640400',
		中卫市: '640500',
		乌鲁木齐市: '650100',
		克拉玛依市: '650200',
		吐鲁番市: '650400',
		哈密市: '650500',
		昌吉回族自治州: '652300',
		博尔塔拉蒙古自治州: '652700',
		巴音郭楞蒙古自治州: '652800',
		阿克苏地区: '652900',
		克孜勒苏柯尔克孜自治州: '653000',
		喀什地区: '653100',
		和田地区: '653200',
		伊犁哈萨克自治州: '654000',
		塔城地区: '654200',
		阿勒泰地区: '654300',
		自治区直辖县级行政区划: '659000',
		台北市: '710100',
		高雄市: '710200',
		台南市: '710300',
		台中市: '710400',
		金门县: '710500',
		南投县: '710600',
		基隆市: '710700',
		新竹市: '710800',
		嘉义市: '710900',
		新北市: '711100',
		宜兰县: '711200',
		新竹县: '711300',
		桃园县: '711400',
		苗栗县: '711500',
		彰化县: '711700',
		嘉义县: '711900',
		云林县: '712100',
		屏东县: '712400',
		台东县: '712500',
		花莲县: '712600',
		澎湖县: '712700',
		连江县: '712800',
		香港岛: '810100',
		九龙: '810200',
		新界: '810300',
		澳门半岛: '820100',
		离岛: '820200',
		阿富汗: '900400',
		阿尔巴尼亚: '900800',
		南极洲: '901000',
		阿尔及利亚: '901200',
		美属萨摩亚: '901600',
		安道尔: '902000',
		安哥拉: '902400',
		安提瓜和巴布达: '902800',
		阿塞拜疆: '903100',
		阿根廷: '903200',
		澳大利亚: '903600',
		奥地利: '904000',
		巴哈马: '904400',
		巴林: '904800',
		孟加拉: '905000',
		亚美尼亚: '905100',
		巴巴多斯: '905200',
		比利时: '905600',
		百慕大: '906000',
		不丹: '906400',
		玻利维亚: '906800',
		波黑: '907000',
		博茨瓦纳: '907200',
		布韦岛: '907400',
		巴西: '907600',
		伯利兹: '908400',
		英属印度洋领地: '908600',
		所罗门群岛: '909000',
		英属维尔京群岛: '909200',
		文莱: '909600',
		保加利亚: '910000',
		缅甸: '910400',
		布隆迪: '910800',
		白俄罗斯: '911200',
		柬埔寨: '911600',
		喀麦隆: '912000',
		加拿大: '912400',
		佛得角: '913200',
		开曼群岛: '913600',
		中非: '914000',
		斯里兰卡: '914400',
		乍得: '914800',
		智利: '915200',
		圣诞岛: '916200',
		科科斯群岛: '916600',
		哥伦比亚: '917000',
		科摩罗: '917400',
		马约特: '917500',
		'刚果（布）': '917800',
		'刚果（金）': '918000',
		库克群岛: '918400',
		哥斯达黎加: '918800',
		克罗地亚: '919100',
		古巴: '919200',
		塞浦路斯: '919600',
		捷克: '920300',
		贝宁: '920400',
		丹麦: '920800',
		多米尼克: '921200',
		多米尼加: '921400',
		厄瓜多尔: '921800',
		萨尔瓦多: '922200',
		赤道几内亚: '922600',
		埃塞俄比亚: '923100',
		厄立特里亚: '923200',
		爱沙尼亚: '923300',
		法罗群岛: '923400',
		'马尔维纳斯群岛（ 福克兰）': '923800',
		南乔治亚岛和南桑威奇群岛: '923900',
		斐济群岛: '924200',
		芬兰: '924600',
		奥兰群岛: '924800',
		法国: '925000',
		法属圭亚那: '925400',
		法属波利尼西亚: '925800',
		法属南部领地: '926000',
		吉布提: '926200',
		加蓬: '926600',
		格鲁吉亚: '926800',
		冈比亚: '927000',
		巴勒斯坦: '927500',
		德国: '927600',
		加纳: '928800',
		直布罗陀: '929200',
		基里巴斯: '929600',
		希腊: '930000',
		格陵兰: '930400',
		格林纳达: '930800',
		瓜德罗普: '931200',
		关岛: '931600',
		危地马拉: '932000',
		几内亚: '932400',
		圭亚那: '932800',
		海地: '933200',
		赫德岛和麦克唐纳群岛: '933400',
		梵蒂冈: '933600',
		洪都拉斯: '934000',
		匈牙利: '934800',
		冰岛: '935200',
		印度: '935600',
		印尼: '936000',
		伊朗: '936400',
		伊拉克: '936800',
		爱尔兰: '937200',
		以色列: '937600',
		意大利: '938000',
		科特迪瓦: '938400',
		牙买加: '938800',
		日本: '939200',
		哈萨克斯坦: '939800',
		约旦: '940000',
		肯尼亚: '940400',
		'朝鲜 北朝鲜': '940800',
		韩国: '941000',
		科威特: '941400',
		吉尔吉斯斯坦: '941700',
		老挝: '941800',
		黎巴嫩: '942200',
		莱索托: '942600',
		拉脱维亚: '942800',
		利比里亚: '943000',
		利比亚: '943400',
		列支敦士登: '943800',
		立陶宛: '944000',
		卢森堡: '944200',
		马达加斯加: '945000',
		马拉维: '945400',
		马来西亚: '945800',
		马尔代夫: '946200',
		马里: '946600',
		马耳他: '947000',
		马提尼克: '947400',
		毛里塔尼亚: '947800',
		毛里求斯: '948000',
		墨西哥: '948400',
		摩纳哥: '949200',
		蒙古国: '949600',
		摩尔多瓦: '949800',
		黑山: '949900',
		蒙塞拉特岛: '950000',
		摩洛哥: '950400',
		莫桑比克: '950800',
		阿曼: '951200',
		纳米比亚: '951600',
		瑙鲁: '952000',
		尼泊尔: '952400',
		荷兰: '952800',
		阿鲁巴: '953300',
		荷兰加勒比区: '953500',
		新喀里多尼亚: '954000',
		瓦努阿图: '954800',
		新西兰: '955400',
		尼加拉瓜: '955800',
		尼日尔: '956200',
		尼日利亚: '956600',
		纽埃: '957000',
		诺福克岛: '957400',
		挪威: '957800',
		北马里亚纳群岛: '958000',
		美国本土外小岛屿: '958100',
		密克罗尼西亚联邦: '958300',
		马绍尔群岛: '958400',
		帕劳: '958500',
		巴基斯坦: '958600',
		巴拿马: '959100',
		巴布亚新几内亚: '959800',
		巴拉圭: '960000',
		秘鲁: '960400',
		菲律宾: '960800',
		皮特凯恩群岛: '961200',
		波兰: '961600',
		葡萄牙: '962000',
		几内亚比绍: '962400',
		东帝汶: '962600',
		波多黎各: '963000',
		卡塔尔: '963400',
		留尼汪: '963800',
		罗马尼亚: '964200',
		俄罗斯: '964300',
		卢旺达: '964600',
		圣巴泰勒米岛: '965200',
		圣赫勒拿: '965400',
		圣基茨和尼维斯: '965900',
		安圭拉: '966000',
		圣卢西亚: '966200',
		法属圣马丁: '966300',
		圣皮埃尔和密克隆: '966600',
		圣文森特和格林纳丁斯: '967000',
		圣马力诺: '967400',
		圣多美和普林西比: '967800',
		沙特阿拉伯: '968200',
		塞内加尔: '968600',
		塞尔维亚: '968800',
		塞舌尔: '969000',
		塞拉利昂: '969400',
		新加坡: '970200',
		斯洛伐克: '970300',
		越南: '970400',
		斯洛文尼亚: '970500',
		索马里: '970600',
		南非: '971000',
		津巴布韦: '971600',
		西班牙: '972400',
		南苏丹: '972800',
		苏丹: '972900',
		西撒哈拉: '973200',
		苏里南: '974000',
		'斯瓦尔巴群岛和 扬马延岛': '974400',
		斯威士兰: '974800',
		瑞典: '975200',
		瑞士: '975600',
		叙利亚: '976000',
		塔吉克斯坦: '976200',
		泰国: '976400',
		多哥: '976800',
		托克劳: '977200',
		汤加: '977600',
		特立尼达和多巴哥: '978000',
		阿联酋: '978400',
		突尼斯: '978800',
		土耳其: '979200',
		土库曼斯坦: '979500',
		特克斯和凯科斯群岛: '979600',
		图瓦卢: '979800',
		乌干达: '980000',
		乌克兰: '980400',
		马其顿: '980700',
		埃及: '981800',
		英国: '982600',
		根西岛: '983100',
		泽西岛: '983200',
		马恩岛: '983300',
		坦桑尼亚: '983400',
		美国: '984000',
		美属维尔京群岛: '985000',
		布基纳法索: '985400',
		乌拉圭: '985800',
		乌兹别克斯坦: '986000',
		委内瑞拉: '986200',
		瓦利斯和富图纳: '987600',
		萨摩亚: '988200',
		也门: '988700',
		赞比亚: '989400',
	},
	county_list: {
		东城区: '110101',
		西城区: '110102',
		朝阳区: '220104',
		丰台区: '110106',
		石景山区: '110107',
		海淀区: '110108',
		门头沟区: '110109',
		房山区: '110111',
		通州区: '320612',
		顺义区: '110113',
		昌平区: '110114',
		大兴区: '110115',
		怀柔区: '110116',
		平谷区: '110117',
		密云区: '110118',
		延庆区: '110119',
		和平区: '710439',
		河东区: '371312',
		河西区: '120103',
		南开区: '120104',
		河北区: '120105',
		红桥区: '120106',
		东丽区: '120110',
		西青区: '120111',
		津南区: '120112',
		北辰区: '120113',
		武清区: '120114',
		宝坻区: '120115',
		滨海新区: '120116',
		宁河区: '120117',
		静海区: '120118',
		蓟州区: '120119',
		长安区: '610116',
		新华区: '410402',
		井陉矿区: '130107',
		裕华区: '130108',
		藁城区: '130109',
		鹿泉区: '130110',
		栾城区: '130111',
		井陉县: '130121',
		正定县: '130123',
		行唐县: '130125',
		灵寿县: '130126',
		高邑县: '130127',
		深泽县: '130128',
		赞皇县: '130129',
		无极县: '130130',
		平山县: '130131',
		元氏县: '130132',
		赵县: '130133',
		辛集市: '130181',
		晋州市: '130183',
		新乐市: '130184',
		路南区: '130202',
		路北区: '130203',
		古冶区: '130204',
		开平区: '130205',
		丰南区: '130207',
		丰润区: '130208',
		曹妃甸区: '130209',
		滦南县: '130224',
		乐亭县: '130225',
		迁西县: '130227',
		玉田县: '130229',
		遵化市: '130281',
		迁安市: '130283',
		滦州市: '130284',
		海港区: '130302',
		山海关区: '130303',
		北戴河区: '130304',
		抚宁区: '130306',
		青龙满族自治县: '130321',
		昌黎县: '130322',
		卢龙县: '130324',
		经济技术开发区: '440890',
		邯山区: '130402',
		丛台区: '130403',
		复兴区: '130404',
		峰峰矿区: '130406',
		肥乡区: '130407',
		永年区: '130408',
		临漳县: '130423',
		成安县: '130424',
		大名县: '130425',
		涉县: '130426',
		磁县: '130427',
		邱县: '130430',
		鸡泽县: '130431',
		广平县: '130432',
		馆陶县: '130433',
		魏县: '130434',
		曲周县: '130435',
		武安市: '130481',
		襄都区: '130502',
		信都区: '130503',
		邢台县: '130521',
		临城县: '130522',
		内丘县: '130523',
		柏乡县: '130524',
		隆尧县: '130525',
		任县: '130526',
		南和县: '130527',
		宁晋县: '130528',
		巨鹿县: '130529',
		新河县: '130530',
		广宗县: '130531',
		平乡县: '130532',
		威县: '130533',
		清河县: '130534',
		临西县: '130535',
		南宫市: '130581',
		沙河市: '130582',
		竞秀区: '130602',
		莲池区: '130606',
		满城区: '130607',
		清苑区: '130608',
		徐水区: '130609',
		涞水县: '130623',
		阜平县: '130624',
		定兴县: '130626',
		唐县: '130627',
		高阳县: '130628',
		容城县: '130629',
		涞源县: '130630',
		望都县: '130631',
		安新县: '130632',
		易县: '130633',
		曲阳县: '130634',
		蠡县: '130635',
		顺平县: '130636',
		博野县: '130637',
		雄县: '130638',
		涿州市: '130681',
		定州市: '130682',
		安国市: '130683',
		高碑店市: '130684',
		桥东区: '130702',
		桥西区: '130703',
		宣化区: '130705',
		下花园区: '130706',
		万全区: '130708',
		崇礼区: '130709',
		张北县: '130722',
		康保县: '130723',
		沽源县: '130724',
		尚义县: '130725',
		蔚县: '130726',
		阳原县: '130727',
		怀安县: '130728',
		怀来县: '130730',
		涿鹿县: '130731',
		赤城县: '130732',
		双桥区: '130802',
		双滦区: '130803',
		鹰手营子矿区: '130804',
		承德县: '130821',
		兴隆县: '130822',
		滦平县: '130824',
		隆化县: '130825',
		丰宁满族自治县: '130826',
		宽城满族自治县: '130827',
		围场满族蒙古族自治县: '130828',
		平泉市: '130881',
		运河区: '130903',
		沧县: '130921',
		青县: '130922',
		东光县: '130923',
		海兴县: '130924',
		盐山县: '130925',
		肃宁县: '130926',
		南皮县: '130927',
		吴桥县: '130928',
		献县: '130929',
		孟村回族自治县: '130930',
		泊头市: '130981',
		任丘市: '130982',
		黄骅市: '130983',
		河间市: '130984',
		安次区: '131002',
		广阳区: '131003',
		固安县: '131022',
		永清县: '131023',
		香河县: '131024',
		大城县: '131025',
		文安县: '131026',
		大厂回族自治县: '131028',
		霸州市: '131081',
		三河市: '131082',
		开发区: '410590',
		桃城区: '131102',
		冀州区: '131103',
		枣强县: '131121',
		武邑县: '131122',
		武强县: '131123',
		饶阳县: '131124',
		安平县: '131125',
		故城县: '131126',
		景县: '131127',
		阜城县: '131128',
		深州市: '131182',
		小店区: '140105',
		迎泽区: '140106',
		杏花岭区: '140107',
		尖草坪区: '140108',
		万柏林区: '140109',
		晋源区: '140110',
		清徐县: '140121',
		阳曲县: '140122',
		娄烦县: '140123',
		古交市: '140181',
		新荣区: '140212',
		平城区: '140213',
		云冈区: '140214',
		云州区: '140215',
		阳高县: '140221',
		天镇县: '140222',
		广灵县: '140223',
		灵丘县: '140224',
		浑源县: '140225',
		左云县: '140226',
		城区: '441502',
		矿区: '140303',
		郊区: '340711',
		平定县: '140321',
		盂县: '140322',
		潞州区: '140403',
		上党区: '140404',
		屯留区: '140405',
		潞城区: '140406',
		襄垣县: '140423',
		平顺县: '140425',
		黎城县: '140426',
		壶关县: '140427',
		长子县: '140428',
		武乡县: '140429',
		沁县: '140430',
		沁源县: '140431',
		沁水县: '140521',
		阳城县: '140522',
		陵川县: '140524',
		泽州县: '140525',
		高平市: '140581',
		朔城区: '140602',
		平鲁区: '140603',
		山阴县: '140621',
		应县: '140622',
		右玉县: '140623',
		怀仁市: '140681',
		榆次区: '140702',
		榆社县: '140721',
		左权县: '140722',
		和顺县: '140723',
		昔阳县: '140724',
		寿阳县: '140725',
		太谷县: '140726',
		祁县: '140727',
		平遥县: '140728',
		灵石县: '140729',
		介休市: '140781',
		盐湖区: '140802',
		临猗县: '140821',
		万荣县: '140822',
		闻喜县: '140823',
		稷山县: '140824',
		新绛县: '140825',
		绛县: '140826',
		垣曲县: '140827',
		夏县: '140828',
		平陆县: '140829',
		芮城县: '140830',
		永济市: '140881',
		河津市: '140882',
		忻府区: '140902',
		定襄县: '140921',
		五台县: '140922',
		代县: '140923',
		繁峙县: '140924',
		宁武县: '140925',
		静乐县: '140926',
		神池县: '140927',
		五寨县: '140928',
		岢岚县: '140929',
		河曲县: '140930',
		保德县: '140931',
		偏关县: '140932',
		原平市: '140981',
		尧都区: '141002',
		曲沃县: '141021',
		翼城县: '141022',
		襄汾县: '141023',
		洪洞县: '141024',
		古县: '141025',
		安泽县: '141026',
		浮山县: '141027',
		吉县: '141028',
		乡宁县: '141029',
		大宁县: '141030',
		隰县: '141031',
		永和县: '141032',
		蒲县: '141033',
		汾西县: '141034',
		侯马市: '141081',
		霍州市: '141082',
		离石区: '141102',
		文水县: '141121',
		交城县: '141122',
		兴县: '141123',
		临县: '141124',
		柳林县: '141125',
		石楼县: '141126',
		岚县: '141127',
		方山县: '141128',
		中阳县: '141129',
		交口县: '141130',
		孝义市: '141181',
		汾阳市: '141182',
		新城区: '610102',
		回民区: '150103',
		玉泉区: '150104',
		赛罕区: '150105',
		土默特左旗: '150121',
		托克托县: '150122',
		和林格尔县: '150123',
		清水河县: '150124',
		武川县: '150125',
		东河区: '150202',
		昆都仑区: '150203',
		青山区: '420107',
		石拐区: '150205',
		白云鄂博矿区: '150206',
		九原区: '150207',
		土默特右旗: '150221',
		固阳县: '150222',
		达尔罕茂明安联合旗: '150223',
		海勃湾区: '150302',
		海南区: '150303',
		乌达区: '150304',
		红山区: '150402',
		元宝山区: '150403',
		松山区: '710104',
		阿鲁科尔沁旗: '150421',
		巴林左旗: '150422',
		巴林右旗: '150423',
		林西县: '150424',
		克什克腾旗: '150425',
		翁牛特旗: '150426',
		喀喇沁旗: '150428',
		宁城县: '150429',
		敖汉旗: '150430',
		科尔沁区: '150502',
		科尔沁左翼中旗: '150521',
		科尔沁左翼后旗: '150522',
		开鲁县: '150523',
		库伦旗: '150524',
		奈曼旗: '150525',
		扎鲁特旗: '150526',
		霍林郭勒市: '150581',
		东胜区: '150602',
		康巴什区: '150603',
		达拉特旗: '150621',
		准格尔旗: '150622',
		鄂托克前旗: '150623',
		鄂托克旗: '150624',
		杭锦旗: '150625',
		乌审旗: '150626',
		伊金霍洛旗: '150627',
		海拉尔区: '150702',
		扎赉诺尔区: '150703',
		阿荣旗: '150721',
		莫力达瓦达斡尔族自治旗: '150722',
		鄂伦春自治旗: '150723',
		鄂温克族自治旗: '150724',
		陈巴尔虎旗: '150725',
		新巴尔虎左旗: '150726',
		新巴尔虎右旗: '150727',
		满洲里市: '150781',
		牙克石市: '150782',
		扎兰屯市: '150783',
		额尔古纳市: '150784',
		根河市: '150785',
		临河区: '150802',
		五原县: '150821',
		磴口县: '150822',
		乌拉特前旗: '150823',
		乌拉特中旗: '150824',
		乌拉特后旗: '150825',
		杭锦后旗: '150826',
		集宁区: '150902',
		卓资县: '150921',
		化德县: '150922',
		商都县: '150923',
		兴和县: '150924',
		凉城县: '150925',
		察哈尔右翼前旗: '150926',
		察哈尔右翼中旗: '150927',
		察哈尔右翼后旗: '150928',
		四子王旗: '150929',
		丰镇市: '150981',
		乌兰浩特市: '152201',
		阿尔山市: '152202',
		科尔沁右翼前旗: '152221',
		科尔沁右翼中旗: '152222',
		扎赉特旗: '152223',
		突泉县: '152224',
		二连浩特市: '152501',
		锡林浩特市: '152502',
		阿巴嘎旗: '152522',
		苏尼特左旗: '152523',
		苏尼特右旗: '152524',
		东乌珠穆沁旗: '152525',
		西乌珠穆沁旗: '152526',
		太仆寺旗: '152527',
		镶黄旗: '152528',
		正镶白旗: '152529',
		正蓝旗: '152530',
		多伦县: '152531',
		阿拉善左旗: '152921',
		阿拉善右旗: '152922',
		额济纳旗: '152923',
		沈河区: '210103',
		大东区: '210104',
		皇姑区: '210105',
		铁西区: '220302',
		苏家屯区: '210111',
		浑南区: '210112',
		沈北新区: '210113',
		于洪区: '210114',
		辽中区: '210115',
		康平县: '210123',
		法库县: '210124',
		新民市: '210181',
		中山区: '710704',
		西岗区: '210203',
		沙河口区: '210204',
		甘井子区: '210211',
		旅顺口区: '210212',
		金州区: '210213',
		普兰店区: '210214',
		长海县: '210224',
		瓦房店市: '210281',
		庄河市: '210283',
		铁东区: '220303',
		立山区: '210304',
		千山区: '210311',
		台安县: '210321',
		岫岩满族自治县: '210323',
		海城市: '210381',
		高新区: '510791',
		新抚区: '210402',
		东洲区: '210403',
		望花区: '210404',
		顺城区: '210411',
		抚顺县: '210421',
		新宾满族自治县: '210422',
		清原满族自治县: '210423',
		平山区: '210502',
		溪湖区: '210503',
		明山区: '210504',
		南芬区: '210505',
		本溪满族自治县: '210521',
		桓仁满族自治县: '210522',
		元宝区: '210602',
		振兴区: '210603',
		振安区: '210604',
		宽甸满族自治县: '210624',
		东港市: '210681',
		凤城市: '210682',
		古塔区: '210702',
		凌河区: '210703',
		太和区: '210711',
		黑山县: '210726',
		义县: '210727',
		凌海市: '210781',
		北镇市: '210782',
		站前区: '210802',
		西市区: '210803',
		鲅鱼圈区: '210804',
		老边区: '210811',
		盖州市: '210881',
		大石桥市: '210882',
		海州区: '320706',
		新邱区: '210903',
		太平区: '710431',
		清河门区: '210905',
		细河区: '210911',
		阜新蒙古族自治县: '210921',
		彰武县: '210922',
		白塔区: '211002',
		文圣区: '211003',
		宏伟区: '211004',
		弓长岭区: '211005',
		太子河区: '211011',
		辽阳县: '211021',
		灯塔市: '211081',
		双台子区: '211102',
		兴隆台区: '211103',
		大洼区: '211104',
		盘山县: '211122',
		银州区: '211202',
		清河区: '211204',
		铁岭县: '211221',
		西丰县: '211223',
		昌图县: '211224',
		调兵山市: '211281',
		开原市: '211282',
		双塔区: '211302',
		龙城区: '211303',
		朝阳县: '211321',
		建平县: '211322',
		喀喇沁左翼蒙古族自治县: '211324',
		北票市: '211381',
		凌源市: '211382',
		连山区: '211402',
		龙港区: '211403',
		南票区: '211404',
		绥中县: '211421',
		建昌县: '211422',
		兴城市: '211481',
		南关区: '220102',
		宽城区: '220103',
		朝阳区: '220104',
		二道区: '220105',
		绿园区: '220106',
		双阳区: '220112',
		九台区: '220113',
		农安县: '220122',
		// 长春经济技术开发区: '220171',
		// 长春净月高新技术产业开发区: '220172',
		// 长春高新技术产业开发区: '220173',
		// 长春汽车经济技术开发区: '220174',
		榆树市: '220182',
		德惠市: '220183',
		公主岭市: '220184',
		昌邑区: '220202',
		龙潭区: '220203',
		船营区: '220204',
		丰满区: '220211',
		永吉县: '220221',
		蛟河市: '220281',
		桦甸市: '220282',
		舒兰市: '220283',
		磐石市: '220284',
		梨树县: '220322',
		伊通满族自治县: '220323',
		双辽市: '220382',
		龙山区: '220402',
		西安区: '231005',
		东丰县: '220421',
		东辽县: '220422',
		东昌区: '220502',
		二道江区: '220503',
		通化县: '220521',
		辉南县: '220523',
		柳河县: '220524',
		梅河口市: '220581',
		集安市: '220582',
		浑江区: '220602',
		江源区: '220605',
		抚松县: '220621',
		靖宇县: '220622',
		长白朝鲜族自治县: '220623',
		临江市: '220681',
		宁江区: '220702',
		前郭尔罗斯蒙古族自治县: '220721',
		长岭县: '220722',
		乾安县: '220723',
		扶余市: '220781',
		洮北区: '220802',
		镇赉县: '220821',
		通榆县: '220822',
		洮南市: '220881',
		大安市: '220882',
		延吉市: '222401',
		图们市: '222402',
		敦化市: '222403',
		珲春市: '222404',
		龙井市: '222405',
		和龙市: '222406',
		汪清县: '222424',
		安图县: '222426',
		道里区: '230102',
		南岗区: '230103',
		道外区: '230104',
		平房区: '230108',
		松北区: '230109',
		香坊区: '230110',
		呼兰区: '230111',
		阿城区: '230112',
		双城区: '230113',
		依兰县: '230123',
		方正县: '230124',
		宾县: '230125',
		巴彦县: '230126',
		木兰县: '230127',
		通河县: '230128',
		延寿县: '230129',
		尚志市: '230183',
		五常市: '230184',
		龙沙区: '230202',
		建华区: '230203',
		铁锋区: '230204',
		昂昂溪区: '230205',
		富拉尔基区: '230206',
		碾子山区: '230207',
		梅里斯达斡尔族区: '230208',
		龙江县: '230221',
		依安县: '230223',
		泰来县: '230224',
		甘南县: '230225',
		富裕县: '230227',
		克山县: '230229',
		克东县: '230230',
		拜泉县: '230231',
		讷河市: '230281',
		鸡冠区: '230302',
		恒山区: '230303',
		滴道区: '230304',
		梨树区: '230305',
		城子河区: '230306',
		麻山区: '230307',
		鸡东县: '230321',
		虎林市: '230381',
		密山市: '230382',
		向阳区: '230803',
		工农区: '230403',
		南山区: '440305',
		兴安区: '230405',
		东山区: '710360',
		兴山区: '230407',
		萝北县: '230421',
		绥滨县: '230422',
		尖山区: '230502',
		岭东区: '230503',
		四方台区: '230505',
		宝山区: '310113',
		集贤县: '230521',
		友谊县: '230522',
		宝清县: '230523',
		饶河县: '230524',
		萨尔图区: '230602',
		龙凤区: '230603',
		让胡路区: '230604',
		红岗区: '230605',
		大同区: '710102',
		肇州县: '230621',
		肇源县: '230622',
		林甸县: '230623',
		杜尔伯特蒙古族自治县: '230624',
		伊春区: '230702',
		南岔区: '230703',
		友好区: '230704',
		西林区: '230705',
		翠峦区: '230706',
		新青区: '230707',
		美溪区: '230708',
		金山屯区: '230709',
		五营区: '230710',
		乌马河区: '230711',
		汤旺河区: '230712',
		带岭区: '230713',
		乌伊岭区: '230714',
		红星区: '230715',
		上甘岭区: '230716',
		嘉荫县: '230722',
		铁力市: '230781',
		前进区: '230804',
		东风区: '230805',
		桦南县: '230822',
		桦川县: '230826',
		汤原县: '230828',
		同江市: '230881',
		富锦市: '230882',
		抚远市: '230883',
		新兴区: '710201',
		桃山区: '230903',
		茄子河区: '230904',
		勃利县: '230921',
		东安区: '231002',
		阳明区: '231003',
		爱民区: '231004',
		林口县: '231025',
		绥芬河市: '231081',
		海林市: '231083',
		宁安市: '231084',
		穆棱市: '231085',
		东宁市: '231086',
		爱辉区: '231102',
		嫩江县: '231121',
		逊克县: '231123',
		孙吴县: '231124',
		北安市: '231181',
		五大连池市: '231182',
		北林区: '231202',
		望奎县: '231221',
		兰西县: '231222',
		青冈县: '231223',
		庆安县: '231224',
		明水县: '231225',
		绥棱县: '231226',
		安达市: '231281',
		肇东市: '231282',
		海伦市: '231283',
		漠河市: '232701',
		呼玛县: '232721',
		塔河县: '232722',
		松岭区: '232790',
		呼中区: '232791',
		加格达奇区: '232792',
		新林区: '232793',
		黄浦区: '310101',
		徐汇区: '310104',
		长宁区: '310105',
		静安区: '310106',
		普陀区: '330903',
		虹口区: '310109',
		杨浦区: '310110',
		闵行区: '310112',
		嘉定区: '310114',
		浦东新区: '310115',
		金山区: '310116',
		松江区: '310117',
		青浦区: '310118',
		奉贤区: '310120',
		崇明区: '310151',
		玄武区: '320102',
		秦淮区: '320104',
		建邺区: '320105',
		鼓楼区: '410204',
		浦口区: '320111',
		栖霞区: '320113',
		雨花台区: '320114',
		江宁区: '320115',
		六合区: '320116',
		溧水区: '320117',
		高淳区: '320118',
		锡山区: '320205',
		惠山区: '320206',
		滨湖区: '320211',
		梁溪区: '320213',
		新吴区: '320214',
		江阴市: '320281',
		宜兴市: '320282',
		云龙区: '320303',
		贾汪区: '320305',
		泉山区: '320311',
		铜山区: '320312',
		丰县: '320321',
		沛县: '320322',
		睢宁县: '320324',
		新沂市: '320381',
		邳州市: '320382',
		工业园区: '320590',
		天宁区: '320402',
		钟楼区: '320404',
		新北区: '320411',
		武进区: '320412',
		金坛区: '320413',
		溧阳市: '320481',
		虎丘区: '320505',
		吴中区: '320506',
		相城区: '320507',
		姑苏区: '320508',
		吴江区: '320509',
		常熟市: '320581',
		张家港市: '320582',
		昆山市: '320583',
		太仓市: '320585',
		崇川区: '320602',
		港闸区: '320611',
		如东县: '320623',
		启东市: '320681',
		如皋市: '320682',
		海门市: '320684',
		海安市: '320685',
		连云区: '320703',
		赣榆区: '320707',
		东海县: '320722',
		灌云县: '320723',
		灌南县: '320724',
		淮安区: '320803',
		淮阴区: '320804',
		清江浦区: '320812',
		洪泽区: '320813',
		涟水县: '320826',
		盱眙县: '320830',
		金湖县: '320831',
		经济开发区: '420590',
		亭湖区: '320902',
		盐都区: '320903',
		大丰区: '320904',
		响水县: '320921',
		滨海县: '320922',
		阜宁县: '320923',
		射阳县: '320924',
		建湖县: '320925',
		东台市: '320981',
		广陵区: '321002',
		邗江区: '321003',
		江都区: '321012',
		宝应县: '321023',
		仪征市: '321081',
		高邮市: '321084',
		京口区: '321102',
		润州区: '321111',
		丹徒区: '321112',
		丹阳市: '321181',
		扬中市: '321182',
		句容市: '321183',
		海陵区: '321202',
		高港区: '321203',
		姜堰区: '321204',
		兴化市: '321281',
		靖江市: '321282',
		泰兴市: '321283',
		宿城区: '321302',
		宿豫区: '321311',
		沭阳县: '321322',
		泗阳县: '321323',
		泗洪县: '321324',
		上城区: '330102',
		下城区: '330103',
		江干区: '330104',
		拱墅区: '330105',
		西湖区: '360103',
		滨江区: '330108',
		萧山区: '330109',
		余杭区: '330110',
		富阳区: '330111',
		临安区: '330112',
		临平区: '330113',
		钱塘区: '330114',
		桐庐县: '330122',
		淳安县: '330127',
		建德市: '330182',
		海曙区: '330203',
		江北区: '500105',
		北仑区: '330206',
		镇海区: '330211',
		鄞州区: '330212',
		奉化区: '330213',
		象山县: '330225',
		宁海县: '330226',
		余姚市: '330281',
		慈溪市: '330282',
		鹿城区: '330302',
		龙湾区: '330303',
		瓯海区: '330304',
		洞头区: '330305',
		永嘉县: '330324',
		平阳县: '330326',
		苍南县: '330327',
		文成县: '330328',
		泰顺县: '330329',
		瑞安市: '330381',
		乐清市: '330382',
		南湖区: '330402',
		秀洲区: '330411',
		嘉善县: '330421',
		海盐县: '330424',
		海宁市: '330481',
		平湖市: '330482',
		桐乡市: '330483',
		吴兴区: '330502',
		南浔区: '330503',
		德清县: '330521',
		长兴县: '330522',
		安吉县: '330523',
		越城区: '330602',
		柯桥区: '330603',
		上虞区: '330604',
		新昌县: '330624',
		诸暨市: '330681',
		嵊州市: '330683',
		婺城区: '330702',
		金东区: '330703',
		武义县: '330723',
		浦江县: '330726',
		磐安县: '330727',
		兰溪市: '330781',
		义乌市: '330782',
		东阳市: '330783',
		永康市: '330784',
		柯城区: '330802',
		衢江区: '330803',
		常山县: '330822',
		开化县: '330824',
		龙游县: '330825',
		江山市: '330881',
		定海区: '330902',
		岱山县: '330921',
		嵊泗县: '330922',
		椒江区: '331002',
		黄岩区: '331003',
		路桥区: '331004',
		三门县: '331022',
		天台县: '331023',
		仙居县: '331024',
		温岭市: '331081',
		临海市: '331082',
		玉环市: '331083',
		莲都区: '331102',
		青田县: '331121',
		缙云县: '331122',
		遂昌县: '331123',
		松阳县: '331124',
		云和县: '331125',
		庆元县: '331126',
		景宁畲族自治县: '331127',
		龙泉市: '331181',
		瑶海区: '340102',
		庐阳区: '340103',
		蜀山区: '340104',
		包河区: '340111',
		长丰县: '340121',
		肥东县: '340122',
		肥西县: '340123',
		庐江县: '340124',
		巢湖市: '340181',
		高新技术开发区: '410190',
		镜湖区: '340202',
		弋江区: '340203',
		鸠江区: '340207',
		三山区: '340208',
		芜湖县: '340221',
		繁昌县: '340222',
		南陵县: '340223',
		无为县: '340225',
		龙子湖区: '340302',
		蚌山区: '340303',
		禹会区: '340304',
		淮上区: '340311',
		怀远县: '340321',
		五河县: '340322',
		固镇县: '340323',
		大通区: '340402',
		田家庵区: '340403',
		谢家集区: '340404',
		八公山区: '340405',
		潘集区: '340406',
		凤台县: '340421',
		寿县: '340422',
		花山区: '340503',
		雨山区: '340504',
		博望区: '340506',
		当涂县: '340521',
		含山县: '340522',
		和县: '340523',
		杜集区: '340602',
		相山区: '340603',
		烈山区: '340604',
		濉溪县: '340621',
		铜官区: '340705',
		义安区: '340706',
		枞阳县: '340722',
		迎江区: '340802',
		大观区: '340803',
		宜秀区: '340811',
		怀宁县: '340822',
		潜山县: '340824',
		太湖县: '340825',
		宿松县: '340826',
		望江县: '340827',
		岳西县: '340828',
		桐城市: '340881',
		屯溪区: '341002',
		黄山区: '341003',
		徽州区: '341004',
		歙县: '341021',
		休宁县: '341022',
		黟县: '341023',
		祁门县: '341024',
		琅琊区: '341102',
		南谯区: '341103',
		来安县: '341122',
		全椒县: '341124',
		定远县: '341125',
		凤阳县: '341126',
		天长市: '341181',
		明光市: '341182',
		颍州区: '341202',
		颍东区: '341203',
		颍泉区: '341204',
		临泉县: '341221',
		太和县: '341222',
		阜南县: '341225',
		颍上县: '341226',
		界首市: '341282',
		埇桥区: '341302',
		砀山县: '341321',
		萧县: '341322',
		灵璧县: '341323',
		泗县: '341324',
		金安区: '341502',
		裕安区: '341503',
		叶集区: '341504',
		霍邱县: '341522',
		舒城县: '341523',
		金寨县: '341524',
		霍山县: '341525',
		谯城区: '341602',
		涡阳县: '341621',
		蒙城县: '341622',
		利辛县: '341623',
		贵池区: '341702',
		东至县: '341721',
		石台县: '341722',
		青阳县: '341723',
		宣州区: '341802',
		郎溪县: '341821',
		广德县: '341822',
		泾县: '341823',
		绩溪县: '341824',
		旌德县: '341825',
		宁国市: '341881',
		台江区: '350103',
		仓山区: '350104',
		马尾区: '350105',
		晋安区: '350111',
		长乐区: '350112',
		闽侯县: '350121',
		连江县: '350122',
		罗源县: '350123',
		闽清县: '350124',
		永泰县: '350125',
		平潭县: '350128',
		福清市: '350181',
		思明区: '350203',
		海沧区: '350205',
		湖里区: '350206',
		集美区: '350211',
		同安区: '350212',
		翔安区: '350213',
		城厢区: '350302',
		涵江区: '350303',
		荔城区: '350304',
		秀屿区: '350305',
		仙游县: '350322',
		梅列区: '350402',
		三元区: '350403',
		明溪县: '350421',
		清流县: '350423',
		宁化县: '350424',
		大田县: '350425',
		尤溪县: '350426',
		沙县: '350427',
		将乐县: '350428',
		泰宁县: '350429',
		建宁县: '350430',
		永安市: '350481',
		鲤城区: '350502',
		丰泽区: '350503',
		洛江区: '350504',
		泉港区: '350505',
		惠安县: '350521',
		安溪县: '350524',
		永春县: '350525',
		德化县: '350526',
		金门县: '350527',
		石狮市: '350581',
		晋江市: '350582',
		南安市: '350583',
		芗城区: '350602',
		龙文区: '350603',
		云霄县: '350622',
		漳浦县: '350623',
		诏安县: '350624',
		长泰县: '350625',
		东山县: '350626',
		南靖县: '350627',
		平和县: '350628',
		华安县: '350629',
		龙海市: '350681',
		延平区: '350702',
		建阳区: '350703',
		顺昌县: '350721',
		浦城县: '350722',
		光泽县: '350723',
		松溪县: '350724',
		政和县: '350725',
		邵武市: '350781',
		武夷山市: '350782',
		建瓯市: '350783',
		新罗区: '350802',
		永定区: '430802',
		长汀县: '350821',
		上杭县: '350823',
		武平县: '350824',
		连城县: '350825',
		漳平市: '350881',
		蕉城区: '350902',
		霞浦县: '350921',
		古田县: '350922',
		屏南县: '350923',
		寿宁县: '350924',
		周宁县: '350925',
		柘荣县: '350926',
		福安市: '350981',
		福鼎市: '350982',
		//江西省
		东湖区: '360102',
		西湖区: '360103', // 有重复
		青云谱区: '360104',
		湾里区: '360105',
		青山湖区: '360111',
		新建区: '360112',
		红谷滩区: '360113',
		南昌县: '360121',
		安义县: '360123',
		进贤县: '360124',
		昌江区: '360202',
		珠山区: '360203',
		浮梁县: '360222',
		乐平市: '360281',
		安源区: '360302',
		湘东区: '360313',
		莲花县: '360321',
		上栗县: '360322',
		芦溪县: '360323',
		濂溪区: '360402',
		浔阳区: '360403',
		柴桑区: '360404',
		武宁县: '360423',
		修水县: '360424',
		永修县: '360425',
		德安县: '360426',
		都昌县: '360428',
		湖口县: '360429',
		彭泽县: '360430',
		瑞昌市: '360481',
		共青城市: '360482',
		庐山市: '360483',
		渝水区: '360502',
		分宜县: '360521',
		月湖区: '360602',
		余江区: '360603',
		贵溪市: '360681',

		章贡区: '360702',
		南康区: '360703',
		赣县区: '360704',
		信丰县: '360722',
		大余县: '360723',
		上犹县: '360724',
		崇义县: '360725',
		安远县: '360726',
		定南县: '360728',
		全南县: '360729',
		宁都县: '360730',
		于都县: '360731',
		兴国县: '360732',
		会昌县: '360733',
		寻乌县: '360734',
		石城县: '360735',
		瑞金市: '360781',
		龙南市: '360783',
		吉州区: '360802',
		青原区: '360803',
		吉安县: '360821',
		吉水县: '360822',
		峡江县: '360823',
		新干县: '360824',
		永丰县: '360825',
		泰和县: '360826',
		遂川县: '360827',
		万安县: '360828',
		安福县: '360829',
		永新县: '360830',
		井冈山市: '360881',
		袁州区: '360902',
		奉新县: '360921',
		万载县: '360922',
		上高县: '360923',
		宜丰县: '360924',
		靖安县: '360925',
		铜鼓县: '360926',
		丰城市: '360981',
		樟树市: '360982',
		高安市: '360983',
		临川区: '361002',
		东乡区: '361003',
		南城县: '361021',
		黎川县: '361022',
		南丰县: '361023',
		崇仁县: '361024',
		乐安县: '361025',
		宜黄县: '361026',
		金溪县: '361027',
		资溪县: '361028',
		广昌县: '361030',
		信州区: '361102',
		广丰区: '361103',
		广信区: '361104',
		玉山县: '361123',
		铅山县: '361124',
		横峰县: '361125',
		弋阳县: '361126',
		余干县: '361127',
		鄱阳县: '361128',
		万年县: '361129',
		婺源县: '361130',
		德兴市: '361181',
		// 江西结束
		历下区: '370102',
		市中区: '511102',
		槐荫区: '370104',
		天桥区: '370105',
		历城区: '370112',
		长清区: '370113',
		章丘区: '370114',
		济阳区: '370115',
		莱芜区: '370116',
		钢城区: '370117',
		平阴县: '370124',
		商河县: '370126',
		市南区: '370202',
		市北区: '370203',
		黄岛区: '370211',
		崂山区: '370212',
		李沧区: '370213',
		城阳区: '370214',
		即墨区: '370215',
		胶州市: '370281',
		平度市: '370283',
		莱西市: '370285',
		淄川区: '370302',
		张店区: '370303',
		博山区: '370304',
		临淄区: '370305',
		周村区: '370306',
		桓台县: '370321',
		高青县: '370322',
		沂源县: '370323',
		薛城区: '370403',
		峄城区: '370404',
		台儿庄区: '370405',
		山亭区: '370406',
		滕州市: '370481',
		东营区: '370502',
		河口区: '370503',
		垦利区: '370505',
		利津县: '370522',
		广饶县: '370523',
		芝罘区: '370602',
		福山区: '370611',
		牟平区: '370612',
		莱山区: '370613',
		长岛县: '370634',
		龙口市: '370681',
		莱阳市: '370682',
		莱州市: '370683',
		蓬莱市: '370684',
		招远市: '370685',
		栖霞市: '370686',
		海阳市: '370687',
		潍城区: '370702',
		寒亭区: '370703',
		坊子区: '370704',
		奎文区: '370705',
		临朐县: '370724',
		昌乐县: '370725',
		青州市: '370781',
		诸城市: '370782',
		寿光市: '370783',
		安丘市: '370784',
		高密市: '370785',
		昌邑市: '370786',
		任城区: '370811',
		兖州区: '370812',
		微山县: '370826',
		鱼台县: '370827',
		金乡县: '370828',
		嘉祥县: '370829',
		汶上县: '370830',
		泗水县: '370831',
		梁山县: '370832',
		曲阜市: '370881',
		邹城市: '370883',
		泰山区: '711151',
		岱岳区: '370911',
		宁阳县: '370921',
		东平县: '370923',
		新泰市: '370982',
		肥城市: '370983',
		环翠区: '371002',
		文登区: '371003',
		荣成市: '371082',
		乳山市: '371083',
		东港区: '371102',
		岚山区: '371103',
		五莲县: '371121',
		莒县: '371122',
		兰山区: '371302',
		罗庄区: '371311',
		沂南县: '371321',
		郯城县: '371322',
		沂水县: '371323',
		兰陵县: '371324',
		费县: '371325',
		平邑县: '371326',
		莒南县: '371327',
		蒙阴县: '371328',
		临沭县: '371329',
		德城区: '371402',
		陵城区: '371403',
		宁津县: '371422',
		庆云县: '371423',
		临邑县: '371424',
		齐河县: '371425',
		平原县: '371426',
		夏津县: '371427',
		武城县: '371428',
		乐陵市: '371481',
		禹城市: '371482',
		东昌府区: '371502',
		阳谷县: '371521',
		莘县: '371522',
		茌平县: '371523',
		东阿县: '371524',
		冠县: '371525',
		高唐县: '371526',
		临清市: '371581',
		滨城区: '371602',
		沾化区: '371603',
		惠民县: '371621',
		阳信县: '371622',
		无棣县: '371623',
		博兴县: '371625',
		邹平市: '371681',
		牡丹区: '371702',
		定陶区: '371703',
		曹县: '371721',
		单县: '371722',
		成武县: '371723',
		巨野县: '371724',
		郓城县: '371725',
		鄄城县: '371726',
		东明县: '371728',
		中原区: '410102',
		二七区: '410103',
		管城回族区: '410104',
		金水区: '410105',
		上街区: '410106',
		惠济区: '410108',
		中牟县: '410122',
		巩义市: '410181',
		荥阳市: '410182',
		新密市: '410183',
		新郑市: '410184',
		登封市: '410185',
		龙亭区: '410202',
		顺河回族区: '410203',
		禹王台区: '410205',
		祥符区: '410212',
		杞县: '410221',
		通许县: '410222',
		尉氏县: '410223',
		兰考县: '410225',
		老城区: '410302',
		西工区: '410303',
		瀍河回族区: '410304',
		涧西区: '410305',
		吉利区: '410306',
		洛龙区: '410311',
		孟津县: '410322',
		新安县: '410323',
		栾川县: '410324',
		嵩县: '410325',
		汝阳县: '410326',
		宜阳县: '410327',
		洛宁县: '410328',
		伊川县: '410329',
		偃师市: '410381',
		卫东区: '410403',
		石龙区: '410404',
		湛河区: '410411',
		宝丰县: '410421',
		叶县: '410422',
		鲁山县: '410423',
		郏县: '410425',
		舞钢市: '410481',
		汝州市: '410482',
		文峰区: '410502',
		北关区: '410503',
		殷都区: '410505',
		龙安区: '410506',
		安阳县: '410522',
		汤阴县: '410523',
		滑县: '410526',
		内黄县: '410527',
		林州市: '410581',
		鹤山区: '410602',
		山城区: '410603',
		淇滨区: '410611',
		浚县: '410621',
		淇县: '410622',
		红旗区: '410702',
		卫滨区: '410703',
		凤泉区: '410704',
		牧野区: '410711',
		新乡县: '410721',
		获嘉县: '410724',
		原阳县: '410725',
		延津县: '410726',
		封丘县: '410727',
		长垣县: '410728',
		卫辉市: '410781',
		辉县市: '410782',
		解放区: '410802',
		中站区: '410803',
		马村区: '410804',
		山阳区: '410811',
		修武县: '410821',
		博爱县: '410822',
		武陟县: '410823',
		温县: '410825',
		沁阳市: '410882',
		孟州市: '410883',
		华龙区: '410902',
		清丰县: '410922',
		南乐县: '410923',
		范县: '410926',
		台前县: '410927',
		濮阳县: '410928',
		魏都区: '411002',
		建安区: '411003',
		鄢陵县: '411024',
		襄城县: '411025',
		禹州市: '411081',
		长葛市: '411082',
		源汇区: '411102',
		郾城区: '411103',
		召陵区: '411104',
		舞阳县: '411121',
		临颍县: '411122',
		湖滨区: '411202',
		陕州区: '411203',
		渑池县: '411221',
		卢氏县: '411224',
		义马市: '411281',
		灵宝市: '411282',
		宛城区: '411302',
		卧龙区: '411303',
		南召县: '411321',
		方城县: '411322',
		西峡县: '411323',
		镇平县: '411324',
		内乡县: '411325',
		淅川县: '411326',
		社旗县: '411327',
		唐河县: '411328',
		新野县: '411329',
		桐柏县: '411330',
		邓州市: '411381',
		梁园区: '411402',
		睢阳区: '411403',
		民权县: '411421',
		睢县: '411422',
		宁陵县: '411423',
		柘城县: '411424',
		虞城县: '411425',
		夏邑县: '411426',
		永城市: '411481',
		浉河区: '411502',
		平桥区: '411503',
		罗山县: '411521',
		光山县: '411522',
		新县: '411523',
		商城县: '411524',
		固始县: '411525',
		潢川县: '411526',
		淮滨县: '411527',
		息县: '411528',
		川汇区: '411602',
		扶沟县: '411621',
		西华县: '411622',
		商水县: '411623',
		沈丘县: '411624',
		郸城县: '411625',
		淮阳县: '411626',
		太康县: '411627',
		鹿邑县: '411628',
		项城市: '411681',
		驿城区: '411702',
		西平县: '411721',
		上蔡县: '411722',
		平舆县: '411723',
		正阳县: '411724',
		确山县: '411725',
		泌阳县: '411726',
		汝南县: '411727',
		遂平县: '411728',
		新蔡县: '411729',
		济源市: '419001',
		江岸区: '420102',
		江汉区: '420103',
		硚口区: '420104',
		汉阳区: '420105',
		武昌区: '420106',
		洪山区: '420111',
		东西湖区: '420112',
		汉南区: '420113',
		蔡甸区: '420114',
		江夏区: '420115',
		黄陂区: '420116',
		新洲区: '420117',
		黄石港区: '420202',
		西塞山区: '420203',
		下陆区: '420204',
		铁山区: '420205',
		阳新县: '420222',
		大冶市: '420281',
		茅箭区: '420302',
		张湾区: '420303',
		郧阳区: '420304',
		郧西县: '420322',
		竹山县: '420323',
		竹溪县: '420324',
		房县: '420325',
		丹江口市: '420381',
		西陵区: '420502',
		伍家岗区: '420503',
		点军区: '420504',
		猇亭区: '420505',
		夷陵区: '420506',
		远安县: '420525',
		兴山县: '420526',
		秭归县: '420527',
		长阳土家族自治县: '420528',
		五峰土家族自治县: '420529',
		宜都市: '420581',
		当阳市: '420582',
		枝江市: '420583',
		襄城区: '420602',
		樊城区: '420606',
		襄州区: '420607',
		南漳县: '420624',
		谷城县: '420625',
		保康县: '420626',
		老河口市: '420682',
		枣阳市: '420683',
		宜城市: '420684',
		梁子湖区: '420702',
		华容区: '420703',
		鄂城区: '420704',
		东宝区: '420802',
		掇刀区: '420804',
		沙洋县: '420822',
		钟祥市: '420881',
		京山市: '420882',
		孝南区: '420902',
		孝昌县: '420921',
		大悟县: '420922',
		云梦县: '420923',
		应城市: '420981',
		安陆市: '420982',
		汉川市: '420984',
		沙市区: '421002',
		荆州区: '421003',
		公安县: '421022',
		监利县: '421023',
		江陵县: '421024',
		石首市: '421081',
		洪湖市: '421083',
		松滋市: '421087',
		黄州区: '421102',
		团风县: '421121',
		红安县: '421122',
		罗田县: '421123',
		英山县: '421124',
		浠水县: '421125',
		蕲春县: '421126',
		黄梅县: '421127',
		麻城市: '421181',
		武穴市: '421182',
		咸安区: '421202',
		嘉鱼县: '421221',
		通城县: '421222',
		崇阳县: '421223',
		通山县: '421224',
		赤壁市: '421281',
		曾都区: '421303',
		随县: '421321',
		广水市: '421381',
		恩施市: '422801',
		利川市: '422802',
		建始县: '422822',
		巴东县: '422823',
		宣恩县: '422825',
		咸丰县: '422826',
		来凤县: '422827',
		鹤峰县: '422828',
		仙桃市: '429004',
		潜江市: '429005',
		天门市: '429006',
		神农架林区: '429021',
		芙蓉区: '430102',
		天心区: '430103',
		岳麓区: '430104',
		开福区: '430105',
		雨花区: '430111',
		望城区: '430112',
		长沙县: '430121',
		浏阳市: '430181',
		宁乡市: '430182',
		荷塘区: '430202',
		芦淞区: '430203',
		石峰区: '430204',
		天元区: '430211',
		渌口区: '430212',
		攸县: '430223',
		茶陵县: '430224',
		炎陵县: '430225',
		醴陵市: '430281',
		雨湖区: '430302',
		岳塘区: '430304',
		湘潭县: '430321',
		湘乡市: '430381',
		韶山市: '430382',
		珠晖区: '430405',
		雁峰区: '430406',
		石鼓区: '430407',
		蒸湘区: '430408',
		南岳区: '430412',
		衡阳县: '430421',
		衡南县: '430422',
		衡山县: '430423',
		衡东县: '430424',
		祁东县: '430426',
		耒阳市: '430481',
		常宁市: '430482',
		双清区: '430502',
		大祥区: '430503',
		北塔区: '430511',
		邵东县: '430521',
		新邵县: '430522',
		邵阳县: '430523',
		隆回县: '430524',
		洞口县: '430525',
		绥宁县: '430527',
		新宁县: '430528',
		城步苗族自治县: '430529',
		武冈市: '430581',
		岳阳楼区: '430602',
		云溪区: '430603',
		君山区: '430611',
		岳阳县: '430621',
		华容县: '430623',
		湘阴县: '430624',
		平江县: '430626',
		汨罗市: '430681',
		临湘市: '430682',
		武陵区: '430702',
		鼎城区: '430703',
		安乡县: '430721',
		汉寿县: '430722',
		澧县: '430723',
		临澧县: '430724',
		桃源县: '430725',
		石门县: '430726',
		津市市: '430781',
		武陵源区: '430811',
		慈利县: '430821',
		桑植县: '430822',
		资阳区: '430902',
		赫山区: '430903',
		南县: '430921',
		桃江县: '430922',
		安化县: '430923',
		沅江市: '430981',
		北湖区: '431002',
		苏仙区: '431003',
		桂阳县: '431021',
		宜章县: '431022',
		永兴县: '431023',
		嘉禾县: '431024',
		临武县: '431025',
		汝城县: '431026',
		桂东县: '431027',
		安仁县: '431028',
		资兴市: '431081',
		零陵区: '431102',
		冷水滩区: '431103',
		祁阳县: '431121',
		东安县: '431122',
		双牌县: '431123',
		道县: '431124',
		江永县: '431125',
		宁远县: '431126',
		蓝山县: '431127',
		新田县: '431128',
		江华瑶族自治县: '431129',
		鹤城区: '431202',
		中方县: '431221',
		沅陵县: '431222',
		辰溪县: '431223',
		溆浦县: '431224',
		会同县: '431225',
		麻阳苗族自治县: '431226',
		新晃侗族自治县: '431227',
		芷江侗族自治县: '431228',
		靖州苗族侗族自治县: '431229',
		通道侗族自治县: '431230',
		洪江市: '431281',
		娄星区: '431302',
		双峰县: '431321',
		新化县: '431322',
		冷水江市: '431381',
		涟源市: '431382',
		吉首市: '433101',
		泸溪县: '433122',
		凤凰县: '433123',
		花垣县: '433124',
		保靖县: '433125',
		古丈县: '433126',
		永顺县: '433127',
		龙山县: '433130',
		荔湾区: '440103',
		越秀区: '440104',
		海珠区: '440105',
		天河区: '440106',
		白云区: '520111',
		黄埔区: '440112',
		番禺区: '440113',
		花都区: '440114',
		南沙区: '440115',
		从化区: '440117',
		增城区: '440118',
		武江区: '440203',
		浈江区: '440204',
		曲江区: '440205',
		始兴县: '440222',
		仁化县: '440224',
		翁源县: '440229',
		乳源瑶族自治县: '440232',
		新丰县: '440233',
		乐昌市: '440281',
		南雄市: '440282',
		罗湖区: '440303',
		福田区: '440304',
		南山区: '440305', // 有重复
		宝安区: '440306',
		龙岗区: '440307',
		盐田区: '440308',
		龙华区: '440309',
		坪山区: '440310',
		光明区: '440311',
		香洲区: '440402',
		斗门区: '440403',
		金湾区: '440404',
		龙湖区: '440507',
		金平区: '440511',
		濠江区: '440512',
		潮阳区: '440513',
		潮南区: '440514',
		澄海区: '440515',
		南澳县: '440523',
		禅城区: '440604',
		南海区: '440605',
		顺德区: '440606',
		三水区: '440607',
		高明区: '440608',
		蓬江区: '440703',
		江海区: '440704',
		新会区: '440705',
		台山市: '440781',
		开平市: '440783',
		鹤山市: '440784',
		恩平市: '440785',
		赤坎区: '440802',
		霞山区: '440803',
		坡头区: '440804',
		麻章区: '440811',
		遂溪县: '440823',
		徐闻县: '440825',
		廉江市: '440881',
		雷州市: '440882',
		吴川市: '440883',
		茂南区: '440902',
		电白区: '440904',
		高州市: '440981',
		化州市: '440982',
		信宜市: '440983',
		端州区: '441202',
		鼎湖区: '441203',
		高要区: '441204',
		广宁县: '441223',
		怀集县: '441224',
		封开县: '441225',
		德庆县: '441226',
		四会市: '441284',
		惠城区: '441302',
		惠阳区: '441303',
		博罗县: '441322',
		惠东县: '441323',
		龙门县: '441324',
		梅江区: '441402',
		梅县区: '441403',
		大埔县: '441422',
		丰顺县: '441423',
		五华县: '441424',
		平远县: '441426',
		蕉岭县: '441427',
		兴宁市: '441481',
		城区: '441502', // 重复	汕尾市
		海丰县: '441521',
		陆河县: '441523',
		陆丰市: '441581',
		源城区: '441602',
		紫金县: '441621',
		龙川县: '441622',
		连平县: '441623',
		和平县: '441624',
		东源县: '441625',
		江城区: '441702',
		阳东区: '441704',
		阳西县: '441721',
		阳春市: '441781',
		清城区: '441802',
		清新区: '441803',
		佛冈县: '441821',
		阳山县: '441823',
		连山壮族瑶族自治县: '441825',
		连南瑶族自治县: '441826',
		英德市: '441881',
		连州市: '441882',
		// 东莞市/中山市
		// 东莞start---
		东城街道: '441900003',
		南城街道: '441900004',
		万江街道: '441900005',
		莞城街道: '441900006',
		石碣镇: '441900101',
		石龙镇: '441900102',
		茶山镇: '441900103',
		石排镇: '441900104',
		企石镇: '441900105',
		横沥镇: '441900106',
		桥头镇: '441900107',
		谢岗镇: '441900108',
		东坑镇: '441900109',
		常平镇: '441900110',
		寮步镇: '441900111',
		樟木头镇: '441900112',
		大朗镇: '441900113',
		黄江镇: '441900114',
		清溪镇: '441900115',
		塘厦镇: '441900116',
		凤岗镇: '441900117',
		大岭山镇: '441900118',
		长安镇: '441900119',
		虎门镇: '441900121',
		厚街镇: '441900122',
		沙田镇: '441900123',
		道滘镇: '441900124',
		洪梅镇: '441900125',
		麻涌镇: '441900126',
		望牛墩镇: '441900127',
		中堂镇: '441900128',
		高埗镇: '441900129',
		松山湖: '441900401',
		东莞港: '441900402',
		东莞生态园: '441900403',
		东莞滨海湾新区: '441900404',
		// 东莞end---
		石岐街道: '442000001',
		东区街道: '442000002',
		火炬开发区街道: '442000003',
		西区街道: '442000004',
		南区街道: '442000005',
		五桂山街道: '442000006',
		// 民众街道: '442000007',
		南朗街道: '442000008',
		黄圃镇: '442000101',
		民众街道: '442000102',
		东凤镇: '442000103',
		古镇镇: '442000105',
		沙溪镇: '442000106',
		坦洲镇: '442000107',
		港口镇: '442000108',
		三角镇: '442000109',
		横栏镇: '442000110',
		南头镇: '442000111',
		阜沙镇: '442000112',
		三乡镇: '442000114',
		板芙镇: '442000115',
		大涌镇: '442000116',
		神湾镇: '442000117',
		小榄镇: '442000100',
		// 小榄镇: '442000118',
		//中山end
		// 原来的code
		// 中堂镇: '441901',
		// 南城街道办事处: '441903',
		// 长安镇: '441904',
		// 东坑镇: '441905',
		// 樟木头镇: '441906',
		// 莞城街道办事处: '441907',
		// 石龙镇: '441908',
		// 桥头镇: '441909',
		// 万江街道办事处: '441910',
		// 麻涌镇: '441911',
		// 虎门镇: '441912',
		// 谢岗镇: '441913',
		// 石碣镇: '441914',
		// 茶山镇: '441915',
		// 东城街道办事处: '441916',
		// 洪梅镇: '441917',
		// 道滘镇: '441918',
		// 高埗镇: '441919',
		// 企石镇: '441920',
		// 凤岗镇: '441921',
		// 大岭山镇: '441922',
		// 松山湖管委会: '441923',
		// 清溪镇: '441924',
		// 望牛墩镇: '441925',
		// 厚街镇: '441926',
		// 常平镇: '441927',
		// 寮步镇: '441928',
		// 石排镇: '441929',
		// 横沥镇: '441930',
		// 塘厦镇: '441931',
		// 黄江镇: '441932',
		// 大朗镇: '441933',
		// 东莞港: '441934',
		// 东莞生态园: '441935',
		// 沙田镇: '441990',
		// 南头镇: '442001',
		// 神湾镇: '442002',
		// 东凤镇: '442003',
		// 五桂山街道办事处: '442004',
		// 黄圃镇: '442005',
		// 小榄镇: '442006',
		// 石岐区街道办事处: '442007',
		// 横栏镇: '442008',
		// 三角镇: '442009',
		// 三乡镇: '442010',
		// 港口镇: '442011',
		// 沙溪镇: '442012',
		// 板芙镇: '442013',
		// 东升镇: '442015',
		// 阜沙镇: '442016',
		// 民众镇: '442017',
		// 东区街道办事处: '442018',
		// 火炬开发区街道办事处: '442019',
		// 西区街道办事处: '442020',
		// 南区街道办事处: '442021',
		// 古镇镇: '442022',
		// 坦洲镇: '442023',
		// 大涌镇: '442024',
		// 南朗镇: '442025',
		// 结束
		湘桥区: '445102',
		潮安区: '445103',
		饶平县: '445122',
		榕城区: '445202',
		揭东区: '445203',
		揭西县: '445222',
		惠来县: '445224',
		普宁市: '445281',
		云城区: '445302',
		云安区: '445303',
		新兴县: '445321',
		郁南县: '445322',
		罗定市: '445381',
		兴宁区: '450102',
		青秀区: '450103',
		江南区: '450105',
		西乡塘区: '450107',
		良庆区: '450108',
		邕宁区: '450109',
		武鸣区: '450110',
		隆安县: '450123',
		马山县: '450124',
		上林县: '450125',
		宾阳县: '450126',
		横县: '450127',
		城中区: '630103',
		鱼峰区: '450203',
		柳南区: '450204',
		柳北区: '450205',
		柳江区: '450206',
		柳城县: '450222',
		鹿寨县: '450223',
		融安县: '450224',
		融水苗族自治县: '450225',
		三江侗族自治县: '450226',
		秀峰区: '450302',
		叠彩区: '450303',
		象山区: '450304',
		七星区: '450305',
		雁山区: '450311',
		临桂区: '450312',
		阳朔县: '450321',
		灵川县: '450323',
		全州县: '450324',
		兴安县: '450325',
		永福县: '450326',
		灌阳县: '450327',
		龙胜各族自治县: '450328',
		资源县: '450329',
		平乐县: '450330',
		恭城瑶族自治县: '450332',
		荔浦市: '450381',
		万秀区: '450403',
		长洲区: '450405',
		龙圩区: '450406',
		苍梧县: '450421',
		藤县: '450422',
		蒙山县: '450423',
		岑溪市: '450481',
		海城区: '450502',
		银海区: '450503',
		铁山港区: '450512',
		合浦县: '450521',
		港口区: '450602',
		防城区: '450603',
		上思县: '450621',
		东兴市: '450681',
		钦南区: '450702',
		钦北区: '450703',
		灵山县: '450721',
		浦北县: '450722',
		港北区: '450802',
		港南区: '450803',
		覃塘区: '450804',
		平南县: '450821',
		桂平市: '450881',
		玉州区: '450902',
		福绵区: '450903',
		容县: '450921',
		陆川县: '450922',
		博白县: '450923',
		兴业县: '450924',
		北流市: '450981',
		右江区: '451002',
		田阳县: '451021',
		田东县: '451022',
		平果县: '451023',
		德保县: '451024',
		那坡县: '451026',
		凌云县: '451027',
		乐业县: '451028',
		田林县: '451029',
		西林县: '451030',
		隆林各族自治县: '451031',
		靖西市: '451081',
		八步区: '451102',
		平桂区: '451103',
		昭平县: '451121',
		钟山县: '451122',
		富川瑶族自治县: '451123',
		金城江区: '451202',
		宜州区: '451203',
		南丹县: '451221',
		天峨县: '451222',
		凤山县: '451223',
		东兰县: '451224',
		罗城仫佬族自治县: '451225',
		环江毛南族自治县: '451226',
		巴马瑶族自治县: '451227',
		都安瑶族自治县: '451228',
		大化瑶族自治县: '451229',
		兴宾区: '451302',
		忻城县: '451321',
		象州县: '451322',
		武宣县: '451323',
		金秀瑶族自治县: '451324',
		合山市: '451381',
		江州区: '451402',
		扶绥县: '451421',
		宁明县: '451422',
		龙州县: '451423',
		大新县: '451424',
		天等县: '451425',
		凭祥市: '451481',
		秀英区: '460105',
		琼山区: '460107',
		美兰区: '460108',
		海棠区: '460202',
		吉阳区: '460203',
		天涯区: '460204',
		崖州区: '460205',
		西沙群岛: '460321',
		南沙群岛: '460322',
		中沙群岛的岛礁及其海域: '460323',
		那大镇: '460400100',
		和庆镇: '460400101',
		南丰镇: '460400102',
		大成镇: '460400103',
		雅星镇: '460400104',
		兰洋镇: '460400105',
		光村镇: '460400106',
		木棠镇: '460400107',
		海头镇: '460400108',
		峨蔓镇: '460400109',
		王五镇: '460400111',
		白马井镇: '460400112',
		中和镇: '460400113',
		排浦镇: '460400114',
		东成镇: '460400115',
		新州镇: '460400116',
		洋浦经济开发区: '460400499',
		华南热作学院: '460400500',
		五指山市: '469001',
		琼海市: '469002',
		文昌市: '469005',
		万宁市: '469006',
		东方市: '469007',
		定安县: '469021',
		屯昌县: '469022',
		澄迈县: '469023',
		临高县: '469024',
		白沙黎族自治县: '469025',
		昌江黎族自治县: '469026',
		乐东黎族自治县: '469027',
		陵水黎族自治县: '469028',
		保亭黎族苗族自治县: '469029',
		琼中黎族苗族自治县: '469030',
		万州区: '500101',
		涪陵区: '500102',
		渝中区: '500103',
		大渡口区: '500104',
		沙坪坝区: '500106',
		九龙坡区: '500107',
		南岸区: '500108',
		北碚区: '500109',
		綦江区: '500110',
		大足区: '500111',
		渝北区: '500112',
		巴南区: '500113',
		黔江区: '500114',
		长寿区: '500115',
		江津区: '500116',
		合川区: '500117',
		永川区: '500118',
		南川区: '500119',
		璧山区: '500120',
		铜梁区: '500151',
		潼南区: '500152',
		荣昌区: '500153',
		开州区: '500154',
		梁平区: '500155',
		武隆区: '500156',
		城口县: '500229',
		丰都县: '500230',
		垫江县: '500231',
		忠县: '500233',
		云阳县: '500235',
		奉节县: '500236',
		巫山县: '500237',
		巫溪县: '500238',
		石柱土家族自治县: '500240',
		秀山土家族苗族自治县: '500241',
		酉阳土家族苗族自治县: '500242',
		彭水苗族土家族自治县: '500243',
		锦江区: '510104',
		青羊区: '510105',
		金牛区: '510106',
		武侯区: '510107',
		成华区: '510108',
		龙泉驿区: '510112',
		青白江区: '510113',
		新都区: '510114',
		温江区: '510115',
		双流区: '510116',
		郫都区: '510117',
		金堂县: '510121',
		大邑县: '510129',
		蒲江县: '510131',
		新津县: '510132',
		都江堰市: '510181',
		彭州市: '510182',
		邛崃市: '510183',
		崇州市: '510184',
		简阳市: '510185',
		自流井区: '510302',
		贡井区: '510303',
		大安区: '710451',
		沿滩区: '510311',
		荣县: '510321',
		富顺县: '510322',
		东区: '810103',
		西区: '710902',
		仁和区: '510411',
		米易县: '510421',
		盐边县: '510422',
		江阳区: '510502',
		纳溪区: '510503',
		龙马潭区: '510504',
		泸县: '510521',
		合江县: '510522',
		叙永县: '510524',
		古蔺县: '510525',
		旌阳区: '510603',
		罗江区: '510604',
		中江县: '510623',
		广汉市: '510681',
		什邡市: '510682',
		绵竹市: '510683',
		涪城区: '510703',
		游仙区: '510704',
		安州区: '510705',
		三台县: '510722',
		盐亭县: '510723',
		梓潼县: '510725',
		北川羌族自治县: '510726',
		平武县: '510727',
		江油市: '510781',
		利州区: '510802',
		昭化区: '510811',
		朝天区: '510812',
		旺苍县: '510821',
		青川县: '510822',
		剑阁县: '510823',
		苍溪县: '510824',
		船山区: '510903',
		安居区: '510904',
		蓬溪县: '510921',
		射洪县: '510922',
		大英县: '510923',
		东兴区: '511011',
		威远县: '511024',
		资中县: '511025',
		隆昌市: '511083',
		沙湾区: '511111',
		五通桥区: '511112',
		金口河区: '511113',
		犍为县: '511123',
		井研县: '511124',
		夹江县: '511126',
		沐川县: '511129',
		峨边彝族自治县: '511132',
		马边彝族自治县: '511133',
		峨眉山市: '511181',
		顺庆区: '511302',
		高坪区: '511303',
		嘉陵区: '511304',
		南部县: '511321',
		营山县: '511322',
		蓬安县: '511323',
		仪陇县: '511324',
		西充县: '511325',
		阆中市: '511381',
		东坡区: '511402',
		彭山区: '511403',
		仁寿县: '511421',
		洪雅县: '511423',
		丹棱县: '511424',
		青神县: '511425',
		翠屏区: '511502',
		南溪区: '511503',
		叙州区: '511504',
		江安县: '511523',
		长宁县: '511524',
		高县: '511525',
		珙县: '511526',
		筠连县: '511527',
		兴文县: '511528',
		屏山县: '511529',
		广安区: '511602',
		前锋区: '511603',
		岳池县: '511621',
		武胜县: '511622',
		邻水县: '511623',
		华蓥市: '511681',
		通川区: '511702',
		达川区: '511703',
		宣汉县: '511722',
		开江县: '511723',
		大竹县: '511724',
		渠县: '511725',
		万源市: '511781',
		雨城区: '511802',
		名山区: '511803',
		荥经县: '511822',
		汉源县: '511823',
		石棉县: '511824',
		天全县: '511825',
		芦山县: '511826',
		宝兴县: '511827',
		巴州区: '511902',
		恩阳区: '511903',
		通江县: '511921',
		南江县: '511922',
		平昌县: '511923',
		雁江区: '512002',
		安岳县: '512021',
		乐至县: '512022',
		马尔康市: '513201',
		汶川县: '513221',
		理县: '513222',
		茂县: '513223',
		松潘县: '513224',
		九寨沟县: '513225',
		金川县: '513226',
		小金县: '513227',
		黑水县: '513228',
		壤塘县: '513230',
		阿坝县: '513231',
		若尔盖县: '513232',
		红原县: '513233',
		康定市: '513301',
		泸定县: '513322',
		丹巴县: '513323',
		九龙县: '513324',
		雅江县: '513325',
		道孚县: '513326',
		炉霍县: '513327',
		甘孜县: '513328',
		新龙县: '513329',
		德格县: '513330',
		白玉县: '513331',
		石渠县: '513332',
		色达县: '513333',
		理塘县: '513334',
		巴塘县: '513335',
		乡城县: '513336',
		稻城县: '513337',
		得荣县: '513338',
		西昌市: '513401',
		木里藏族自治县: '513422',
		盐源县: '513423',
		德昌县: '513424',
		会理县: '513425',
		会东县: '513426',
		宁南县: '513427',
		普格县: '513428',
		布拖县: '513429',
		金阳县: '513430',
		昭觉县: '513431',
		喜德县: '513432',
		冕宁县: '513433',
		越西县: '513434',
		甘洛县: '513435',
		美姑县: '513436',
		雷波县: '513437',
		南明区: '520102',
		云岩区: '520103',
		花溪区: '520111',
		乌当区: '520112',
		观山湖区: '520115',
		开阳县: '520121',
		息烽县: '520122',
		修文县: '520123',
		清镇市: '520181',
		钟山区: '520201',
		六枝特区: '520203',
		水城县: '520221',
		盘州市: '520281',
		红花岗区: '520302',
		汇川区: '520303',
		播州区: '520304',
		桐梓县: '520322',
		绥阳县: '520323',
		正安县: '520324',
		道真仡佬族苗族自治县: '520325',
		务川仡佬族苗族自治县: '520326',
		凤冈县: '520327',
		湄潭县: '520328',
		余庆县: '520329',
		习水县: '520330',
		赤水市: '520381',
		仁怀市: '520382',
		西秀区: '520402',
		平坝区: '520403',
		普定县: '520422',
		镇宁布依族苗族自治县: '520423',
		关岭布依族苗族自治县: '520424',
		紫云苗族布依族自治县: '520425',
		七星关区: '520502',
		大方县: '520521',
		黔西县: '520522',
		金沙县: '520523',
		织金县: '520524',
		纳雍县: '520525',
		威宁彝族回族苗族自治县: '520526',
		赫章县: '520527',
		碧江区: '520602',
		万山区: '520603',
		江口县: '520621',
		玉屏侗族自治县: '520622',
		石阡县: '520623',
		思南县: '520624',
		印江土家族苗族自治县: '520625',
		德江县: '520626',
		沿河土家族自治县: '520627',
		松桃苗族自治县: '520628',
		兴义市: '522301',
		兴仁市: '522302',
		普安县: '522323',
		晴隆县: '522324',
		贞丰县: '522325',
		望谟县: '522326',
		册亨县: '522327',
		安龙县: '522328',
		凯里市: '522601',
		黄平县: '522622',
		施秉县: '522623',
		三穗县: '522624',
		镇远县: '522625',
		岑巩县: '522626',
		天柱县: '522627',
		锦屏县: '522628',
		剑河县: '522629',
		台江县: '522630',
		黎平县: '522631',
		榕江县: '522632',
		从江县: '522633',
		雷山县: '522634',
		麻江县: '522635',
		丹寨县: '522636',
		都匀市: '522701',
		福泉市: '522702',
		荔波县: '522722',
		贵定县: '522723',
		瓮安县: '522725',
		独山县: '522726',
		平塘县: '522727',
		罗甸县: '522728',
		长顺县: '522729',
		龙里县: '522730',
		惠水县: '522731',
		三都水族自治县: '522732',
		五华区: '530102',
		盘龙区: '530103',
		官渡区: '530111',
		西山区: '530112',
		东川区: '530113',
		呈贡区: '530114',
		晋宁区: '530115',
		富民县: '530124',
		宜良县: '530125',
		石林彝族自治县: '530126',
		嵩明县: '530127',
		禄劝彝族苗族自治县: '530128',
		寻甸回族彝族自治县: '530129',
		安宁市: '530181',
		麒麟区: '530302',
		沾益区: '530303',
		马龙区: '530304',
		陆良县: '530322',
		师宗县: '530323',
		罗平县: '530324',
		富源县: '530325',
		会泽县: '530326',
		宣威市: '530381',
		红塔区: '530402',
		江川区: '530403',
		澄江县: '530422',
		通海县: '530423',
		华宁县: '530424',
		易门县: '530425',
		峨山彝族自治县: '530426',
		新平彝族傣族自治县: '530427',
		元江哈尼族彝族傣族自治县: '530428',
		隆阳区: '530502',
		施甸县: '530521',
		龙陵县: '530523',
		昌宁县: '530524',
		腾冲市: '530581',
		昭阳区: '530602',
		鲁甸县: '530621',
		巧家县: '530622',
		盐津县: '530623',
		大关县: '530624',
		永善县: '530625',
		绥江县: '530626',
		镇雄县: '530627',
		彝良县: '530628',
		威信县: '530629',
		水富市: '530681',
		古城区: '530702',
		玉龙纳西族自治县: '530721',
		永胜县: '530722',
		华坪县: '530723',
		宁蒗彝族自治县: '530724',
		思茅区: '530802',
		宁洱哈尼族彝族自治县: '530821',
		墨江哈尼族自治县: '530822',
		景东彝族自治县: '530823',
		景谷傣族彝族自治县: '530824',
		镇沅彝族哈尼族拉祜族自治县: '530825',
		江城哈尼族彝族自治县: '530826',
		孟连傣族拉祜族佤族自治县: '530827',
		澜沧拉祜族自治县: '530828',
		西盟佤族自治县: '530829',
		临翔区: '530902',
		凤庆县: '530921',
		云县: '530922',
		永德县: '530923',
		镇康县: '530924',
		双江拉祜族佤族布朗族傣族自治县: '530925',
		耿马傣族佤族自治县: '530926',
		沧源佤族自治县: '530927',
		楚雄市: '532301',
		双柏县: '532322',
		牟定县: '532323',
		南华县: '532324',
		姚安县: '532325',
		大姚县: '532326',
		永仁县: '532327',
		元谋县: '532328',
		武定县: '532329',
		禄丰县: '532331',
		个旧市: '532501',
		开远市: '532502',
		蒙自市: '532503',
		弥勒市: '532504',
		屏边苗族自治县: '532523',
		建水县: '532524',
		石屏县: '532525',
		泸西县: '532527',
		元阳县: '532528',
		红河县: '532529',
		金平苗族瑶族傣族自治县: '532530',
		绿春县: '532531',
		河口瑶族自治县: '532532',
		文山市: '532601',
		砚山县: '532622',
		西畴县: '532623',
		麻栗坡县: '532624',
		马关县: '532625',
		丘北县: '532626',
		广南县: '532627',
		富宁县: '532628',
		景洪市: '532801',
		勐海县: '532822',
		勐腊县: '532823',
		大理市: '532901',
		漾濞彝族自治县: '532922',
		祥云县: '532923',
		宾川县: '532924',
		弥渡县: '532925',
		南涧彝族自治县: '532926',
		巍山彝族回族自治县: '532927',
		永平县: '532928',
		云龙县: '532929',
		洱源县: '532930',
		剑川县: '532931',
		鹤庆县: '532932',
		瑞丽市: '533102',
		芒市: '533103',
		梁河县: '533122',
		盈江县: '533123',
		陇川县: '533124',
		泸水市: '533301',
		福贡县: '533323',
		贡山独龙族怒族自治县: '533324',
		兰坪白族普米族自治县: '533325',
		香格里拉市: '533401',
		德钦县: '533422',
		维西傈僳族自治县: '533423',
		城关区: '620102',
		堆龙德庆区: '540103',
		达孜区: '540104',
		林周县: '540121',
		当雄县: '540122',
		尼木县: '540123',
		曲水县: '540124',
		墨竹工卡县: '540127',
		桑珠孜区: '540202',
		南木林县: '540221',
		江孜县: '540222',
		定日县: '540223',
		萨迦县: '540224',
		拉孜县: '540225',
		昂仁县: '540226',
		谢通门县: '540227',
		白朗县: '540228',
		仁布县: '540229',
		康马县: '540230',
		定结县: '540231',
		仲巴县: '540232',
		亚东县: '540233',
		吉隆县: '540234',
		聂拉木县: '540235',
		萨嘎县: '540236',
		岗巴县: '540237',
		卡若区: '540302',
		江达县: '540321',
		贡觉县: '540322',
		类乌齐县: '540323',
		丁青县: '540324',
		察雅县: '540325',
		八宿县: '540326',
		左贡县: '540327',
		芒康县: '540328',
		洛隆县: '540329',
		边坝县: '540330',
		巴宜区: '540402',
		工布江达县: '540421',
		米林县: '540422',
		墨脱县: '540423',
		波密县: '540424',
		察隅县: '540425',
		朗县: '540426',
		乃东区: '540502',
		扎囊县: '540521',
		贡嘎县: '540522',
		桑日县: '540523',
		琼结县: '540524',
		曲松县: '540525',
		措美县: '540526',
		洛扎县: '540527',
		加查县: '540528',
		隆子县: '540529',
		错那县: '540530',
		浪卡子县: '540531',
		色尼区: '540602',
		嘉黎县: '540621',
		比如县: '540622',
		聂荣县: '540623',
		安多县: '540624',
		申扎县: '540625',
		索县: '540626',
		班戈县: '540627',
		巴青县: '540628',
		尼玛县: '540629',
		双湖县: '540630',
		普兰县: '542521',
		札达县: '542522',
		噶尔县: '542523',
		日土县: '542524',
		革吉县: '542525',
		改则县: '542526',
		措勤县: '542527',
		碑林区: '610103',
		莲湖区: '610104',
		灞桥区: '610111',
		未央区: '610112',
		雁塔区: '610113',
		阎良区: '610114',
		临潼区: '610115',
		高陵区: '610117',
		鄠邑区: '610118',
		蓝田县: '610122',
		周至县: '610124',
		王益区: '610202',
		印台区: '610203',
		耀州区: '610204',
		宜君县: '610222',
		渭滨区: '610302',
		金台区: '610303',
		陈仓区: '610304',
		凤翔县: '610322',
		岐山县: '610323',
		扶风县: '610324',
		眉县: '610326',
		陇县: '610327',
		千阳县: '610328',
		麟游县: '610329',
		凤县: '610330',
		太白县: '610331',
		秦都区: '610402',
		杨陵区: '610403',
		渭城区: '610404',
		三原县: '610422',
		泾阳县: '610423',
		乾县: '610424',
		礼泉县: '610425',
		永寿县: '610426',
		长武县: '610428',
		旬邑县: '610429',
		淳化县: '610430',
		武功县: '610431',
		兴平市: '610481',
		彬州市: '610482',
		临渭区: '610502',
		华州区: '610503',
		潼关县: '610522',
		大荔县: '610523',
		合阳县: '610524',
		澄城县: '610525',
		蒲城县: '610526',
		白水县: '610527',
		富平县: '610528',
		韩城市: '610581',
		华阴市: '610582',
		宝塔区: '610602',
		安塞区: '610603',
		延长县: '610621',
		延川县: '610622',
		子长县: '610623',
		志丹县: '610625',
		吴起县: '610626',
		甘泉县: '610627',
		富县: '610628',
		洛川县: '610629',
		宜川县: '610630',
		黄龙县: '610631',
		黄陵县: '610632',
		汉台区: '610702',
		南郑区: '610703',
		城固县: '610722',
		洋县: '610723',
		西乡县: '610724',
		勉县: '610725',
		宁强县: '610726',
		略阳县: '610727',
		镇巴县: '610728',
		留坝县: '610729',
		佛坪县: '610730',
		榆阳区: '610802',
		横山区: '610803',
		府谷县: '610822',
		靖边县: '610824',
		定边县: '610825',
		绥德县: '610826',
		米脂县: '610827',
		佳县: '610828',
		吴堡县: '610829',
		清涧县: '610830',
		子洲县: '610831',
		神木市: '610881',
		汉滨区: '610902',
		汉阴县: '610921',
		石泉县: '610922',
		宁陕县: '610923',
		紫阳县: '610924',
		岚皋县: '610925',
		平利县: '610926',
		镇坪县: '610927',
		旬阳县: '610928',
		白河县: '610929',
		商州区: '611002',
		洛南县: '611021',
		丹凤县: '611022',
		商南县: '611023',
		山阳县: '611024',
		镇安县: '611025',
		柞水县: '611026',
		七里河区: '620103',
		西固区: '620104',
		安宁区: '620105',
		红古区: '620111',
		永登县: '620121',
		皋兰县: '620122',
		榆中县: '620123',
		市辖区: '620201',
		雄关区: '620290',
		长城区: '620291',
		镜铁区: '620292',
		新城镇: '620293',
		峪泉镇: '620294',
		文殊镇: '620295',
		金川区: '620302',
		永昌县: '620321',
		白银区: '620402',
		平川区: '620403',
		靖远县: '620421',
		会宁县: '620422',
		景泰县: '620423',
		秦州区: '620502',
		麦积区: '620503',
		清水县: '620521',
		秦安县: '620522',
		甘谷县: '620523',
		武山县: '620524',
		张家川回族自治县: '620525',
		凉州区: '620602',
		民勤县: '620621',
		古浪县: '620622',
		天祝藏族自治县: '620623',
		甘州区: '620702',
		肃南裕固族自治县: '620721',
		民乐县: '620722',
		临泽县: '620723',
		高台县: '620724',
		山丹县: '620725',
		崆峒区: '620802',
		泾川县: '620821',
		灵台县: '620822',
		崇信县: '620823',
		庄浪县: '620825',
		静宁县: '620826',
		华亭市: '620881',
		肃州区: '620902',
		金塔县: '620921',
		瓜州县: '620922',
		肃北蒙古族自治县: '620923',
		阿克塞哈萨克族自治县: '620924',
		玉门市: '620981',
		敦煌市: '620982',
		西峰区: '621002',
		庆城县: '621021',
		环县: '621022',
		华池县: '621023',
		合水县: '621024',
		正宁县: '621025',
		宁县: '621026',
		镇原县: '621027',
		安定区: '710369',
		通渭县: '621121',
		陇西县: '621122',
		渭源县: '621123',
		临洮县: '621124',
		漳县: '621125',
		岷县: '621126',
		武都区: '621202',
		成县: '621221',
		文县: '621222',
		宕昌县: '621223',
		康县: '621224',
		西和县: '621225',
		礼县: '621226',
		徽县: '621227',
		两当县: '621228',
		临夏市: '622901',
		临夏县: '622921',
		康乐县: '622922',
		永靖县: '622923',
		广河县: '622924',
		和政县: '622925',
		东乡族自治县: '622926',
		积石山保安族东乡族撒拉族自治县: '622927',
		合作市: '623001',
		临潭县: '623021',
		卓尼县: '623022',
		舟曲县: '623023',
		迭部县: '623024',
		玛曲县: '623025',
		碌曲县: '623026',
		夏河县: '623027',
		城东区: '630102',
		城西区: '630104',
		城北区: '630105',
		大通回族土族自治县: '630121',
		湟中县: '630122',
		湟源县: '630123',
		乐都区: '630202',
		平安区: '630203',
		民和回族土族自治县: '630222',
		互助土族自治县: '630223',
		化隆回族自治县: '630224',
		循化撒拉族自治县: '630225',
		门源回族自治县: '632221',
		祁连县: '632222',
		海晏县: '632223',
		刚察县: '632224',
		同仁县: '632321',
		尖扎县: '632322',
		泽库县: '632323',
		河南蒙古族自治县: '632324',
		共和县: '632521',
		同德县: '632522',
		贵德县: '632523',
		兴海县: '632524',
		贵南县: '632525',
		玛沁县: '632621',
		班玛县: '632622',
		甘德县: '632623',
		达日县: '632624',
		久治县: '632625',
		玛多县: '632626',
		玉树市: '632701',
		杂多县: '632722',
		称多县: '632723',
		治多县: '632724',
		囊谦县: '632725',
		曲麻莱县: '632726',
		格尔木市: '632801',
		德令哈市: '632802',
		茫崖市: '632803',
		乌兰县: '632821',
		都兰县: '632822',
		天峻县: '632823',
		兴庆区: '640104',
		西夏区: '640105',
		金凤区: '640106',
		永宁县: '640121',
		贺兰县: '640122',
		灵武市: '640181',
		大武口区: '640202',
		惠农区: '640205',
		平罗县: '640221',
		利通区: '640302',
		红寺堡区: '640303',
		盐池县: '640323',
		同心县: '640324',
		青铜峡市: '640381',
		原州区: '640402',
		西吉县: '640422',
		隆德县: '640423',
		泾源县: '640424',
		彭阳县: '640425',
		沙坡头区: '640502',
		中宁县: '640521',
		海原县: '640522',
		天山区: '650102',
		沙依巴克区: '650103',
		新市区: '710368',
		水磨沟区: '650105',
		头屯河区: '650106',
		达坂城区: '650107',
		米东区: '650109',
		乌鲁木齐县: '650121',
		独山子区: '650202',
		克拉玛依区: '650203',
		白碱滩区: '650204',
		乌尔禾区: '650205',
		高昌区: '650402',
		鄯善县: '650421',
		托克逊县: '650422',
		伊州区: '650502',
		巴里坤哈萨克自治县: '650521',
		伊吾县: '650522',
		昌吉市: '652301',
		阜康市: '652302',
		呼图壁县: '652323',
		玛纳斯县: '652324',
		奇台县: '652325',
		吉木萨尔县: '652327',
		木垒哈萨克自治县: '652328',
		博乐市: '652701',
		阿拉山口市: '652702',
		精河县: '652722',
		温泉县: '652723',
		库尔勒市: '652801',
		轮台县: '652822',
		尉犁县: '652823',
		若羌县: '652824',
		且末县: '652825',
		焉耆回族自治县: '652826',
		和静县: '652827',
		和硕县: '652828',
		博湖县: '652829',
		阿克苏市: '652901',
		温宿县: '652922',
		库车县: '652923',
		沙雅县: '652924',
		新和县: '652925',
		拜城县: '652926',
		乌什县: '652927',
		阿瓦提县: '652928',
		柯坪县: '652929',
		阿图什市: '653001',
		阿克陶县: '653022',
		阿合奇县: '653023',
		乌恰县: '653024',
		喀什市: '653101',
		疏附县: '653121',
		疏勒县: '653122',
		英吉沙县: '653123',
		泽普县: '653124',
		莎车县: '653125',
		叶城县: '653126',
		麦盖提县: '653127',
		岳普湖县: '653128',
		伽师县: '653129',
		巴楚县: '653130',
		塔什库尔干塔吉克自治县: '653131',
		和田市: '653201',
		和田县: '653221',
		墨玉县: '653222',
		皮山县: '653223',
		洛浦县: '653224',
		策勒县: '653225',
		于田县: '653226',
		民丰县: '653227',
		伊宁市: '654002',
		奎屯市: '654003',
		霍尔果斯市: '654004',
		伊宁县: '654021',
		察布查尔锡伯自治县: '654022',
		霍城县: '654023',
		巩留县: '654024',
		新源县: '654025',
		昭苏县: '654026',
		特克斯县: '654027',
		尼勒克县: '654028',
		塔城市: '654201',
		乌苏市: '654202',
		额敏县: '654221',
		沙湾县: '654223',
		托里县: '654224',
		裕民县: '654225',
		和布克赛尔蒙古自治县: '654226',
		阿勒泰市: '654301',
		布尔津县: '654321',
		富蕴县: '654322',
		福海县: '654323',
		哈巴河县: '654324',
		青河县: '654325',
		吉木乃县: '654326',
		石河子市: '659001',
		阿拉尔市: '659002',
		图木舒克市: '659003',
		五家渠市: '659004',
		北屯市: '659005',
		铁门关市: '659006',
		双河市: '659007',
		可克达拉市: '659008',
		昆玉市: '659009',
		中正区: '710703',
		万华区: '710106',
		信义区: '710702',
		士林区: '710108',
		北投区: '710109',
		内湖区: '710110',
		南港区: '710111',
		文山区: '710112',
		其它区: '710999',
		前金区: '710202',
		芩雅区: '710203',
		盐埕区: '710204',
		鼓山区: '710205',
		旗津区: '710206',
		前镇区: '710207',
		三民区: '710208',
		左营区: '710209',
		楠梓区: '710210',
		小港区: '710211',
		苓雅区: '710241',
		仁武区: '710242',
		大社区: '710243',
		冈山区: '710244',
		路竹区: '710245',
		阿莲区: '710246',
		田寮区: '710247',
		燕巢区: '710248',
		桥头区: '710249',
		梓官区: '710250',
		弥陀区: '710251',
		永安区: '710252',
		湖内区: '710253',
		凤山区: '710254',
		大寮区: '710255',
		林园区: '710256',
		鸟松区: '710257',
		大树区: '710258',
		旗山区: '710259',
		美浓区: '710260',
		六龟区: '710261',
		内门区: '710262',
		杉林区: '710263',
		甲仙区: '710264',
		桃源区: '710265',
		那玛夏区: '710266',
		茂林区: '710267',
		茄萣区: '710268',
		中西区: '810101',
		南区: '810104',
		北区: '810301',
		安平区: '710305',
		安南区: '710306',
		永康区: '710339',
		归仁区: '710340',
		新化区: '710341',
		左镇区: '710342',
		玉井区: '710343',
		楠西区: '710344',
		南化区: '710345',
		仁德区: '710346',
		关庙区: '710347',
		龙崎区: '710348',
		官田区: '710349',
		麻豆区: '710350',
		佳里区: '710351',
		西港区: '710352',
		七股区: '710353',
		将军区: '710354',
		学甲区: '710355',
		北门区: '710356',
		新营区: '710357',
		后壁区: '710358',
		白河区: '710359',
		六甲区: '710361',
		下营区: '710362',
		柳营区: '710363',
		盐水区: '710364',
		善化区: '710365',
		大内区: '710366',
		山上区: '710367',
		中区: '710401',
		北屯区: '710406',
		西屯区: '710407',
		南屯区: '710408',
		大里区: '710432',
		雾峰区: '710433',
		乌日区: '710434',
		丰原区: '710435',
		后里区: '710436',
		石冈区: '710437',
		东势区: '710438',
		新社区: '710440',
		潭子区: '710441',
		大雅区: '710442',
		神冈区: '710443',
		大肚区: '710444',
		沙鹿区: '710445',
		龙井区: '710446',
		梧栖区: '710447',
		清水区: '710448',
		大甲区: '710449',
		外埔区: '710450',
		金沙镇: '710507',
		金湖镇: '710508',
		金宁乡: '710509',
		金城镇: '710510',
		烈屿乡: '710511',
		乌坵乡: '710512',
		南投市: '710614',
		中寮乡: '710615',
		草屯镇: '710616',
		国姓乡: '710617',
		埔里镇: '710618',
		仁爱乡: '710619',
		名间乡: '710620',
		集集镇: '710621',
		水里乡: '710622',
		鱼池乡: '710623',
		信义乡: '710624',
		竹山镇: '710625',
		鹿谷乡: '710626',
		仁爱区: '710701',
		安乐区: '710705',
		暖暖区: '710706',
		七堵区: '710707',
		香山区: '710803',
		万里区: '711130',
		板桥区: '711132',
		汐止区: '711133',
		深坑区: '711134',
		石碇区: '711135',
		瑞芳区: '711136',
		平溪区: '711137',
		双溪区: '711138',
		贡寮区: '711139',
		新店区: '711140',
		坪林区: '711141',
		乌来区: '711142',
		永和区: '711143',
		中和区: '711144',
		土城区: '711145',
		三峡区: '711146',
		树林区: '711147',
		莺歌区: '711148',
		三重区: '711149',
		新庄区: '711150',
		林口区: '711152',
		芦洲区: '711153',
		五股区: '711154',
		八里区: '711155',
		淡水区: '711156',
		三芝区: '711157',
		石门区: '711158',
		宜兰市: '711287',
		头城镇: '711288',
		礁溪乡: '711289',
		壮围乡: '711290',
		员山乡: '711291',
		罗东镇: '711292',
		三星乡: '711293',
		大同乡: '711294',
		五结乡: '711295',
		冬山乡: '711296',
		苏澳镇: '711297',
		南澳乡: '711298',
		钓鱼台: '711299',
		竹北市: '711387',
		湖口乡: '711388',
		新丰乡: '711389',
		新埔镇: '711390',
		关西镇: '711391',
		芎林乡: '711392',
		宝山乡: '711393',
		竹东镇: '711394',
		五峰乡: '711395',
		横山乡: '711396',
		尖石乡: '711397',
		北埔乡: '711398',
		峨眉乡: '711399',
		中坜区: '711414',
		平镇区: '711415',
		杨梅区: '711417',
		新屋区: '711418',
		观音区: '711419',
		桃园区: '711420',
		龟山区: '711421',
		八德区: '711422',
		大溪区: '711423',
		大园区: '711425',
		芦竹区: '711426',
		中坜市: '711487',
		平镇市: '711488',
		龙潭乡: '711489',
		杨梅市: '711490',
		新屋乡: '711491',
		观音乡: '711492',
		桃园市: '711493',
		龟山乡: '711494',
		八德市: '711495',
		大溪镇: '711496',
		复兴乡: '711497',
		大园乡: '711498',
		芦竹乡: '711499',
		头份市: '711520',
		竹南镇: '711582',
		头份镇: '711583',
		三湾乡: '711584',
		南庄乡: '711585',
		狮潭乡: '711586',
		后龙镇: '711587',
		通霄镇: '711588',
		苑里镇: '711589',
		苗栗市: '711590',
		造桥乡: '711591',
		头屋乡: '711592',
		公馆乡: '711593',
		大湖乡: '711594',
		泰安乡: '711595',
		铜锣乡: '711596',
		三义乡: '711597',
		西湖乡: '711598',
		卓兰镇: '711599',
		员林市: '711736',
		彰化市: '711774',
		芬园乡: '711775',
		花坛乡: '711776',
		秀水乡: '711777',
		鹿港镇: '711778',
		福兴乡: '711779',
		线西乡: '711780',
		和美镇: '711781',
		伸港乡: '711782',
		员林镇: '711783',
		社头乡: '711784',
		永靖乡: '711785',
		埔心乡: '711786',
		溪湖镇: '711787',
		大村乡: '711788',
		埔盐乡: '711789',
		田中镇: '711790',
		北斗镇: '711791',
		田尾乡: '711792',
		埤头乡: '711793',
		溪州乡: '711794',
		竹塘乡: '711795',
		二林镇: '711796',
		大城乡: '711797',
		芳苑乡: '711798',
		二水乡: '711799',
		番路乡: '711982',
		梅山乡: '711983',
		竹崎乡: '711984',
		阿里山乡: '711985',
		中埔乡: '711986',
		大埔乡: '711987',
		水上乡: '711988',
		鹿草乡: '711989',
		太保市: '711990',
		朴子市: '711991',
		东石乡: '711992',
		六脚乡: '711993',
		新港乡: '711994',
		民雄乡: '711995',
		大林镇: '711996',
		溪口乡: '711997',
		义竹乡: '711998',
		布袋镇: '711999',
		斗南镇: '712180',
		大埤乡: '712181',
		虎尾镇: '712182',
		土库镇: '712183',
		褒忠乡: '712184',
		东势乡: '712185',
		台西乡: '712186',
		仑背乡: '712187',
		麦寮乡: '712188',
		斗六市: '712189',
		林内乡: '712190',
		古坑乡: '712191',
		莿桐乡: '712192',
		西螺镇: '712193',
		二仑乡: '712194',
		北港镇: '712195',
		水林乡: '712196',
		口湖乡: '712197',
		四湖乡: '712198',
		元长乡: '712199',
		崁顶乡: '712451',
		屏东市: '712467',
		三地门乡: '712468',
		雾台乡: '712469',
		玛家乡: '712470',
		九如乡: '712471',
		里港乡: '712472',
		高树乡: '712473',
		盐埔乡: '712474',
		长治乡: '712475',
		麟洛乡: '712476',
		竹田乡: '712477',
		内埔乡: '712478',
		万丹乡: '712479',
		潮州镇: '712480',
		泰武乡: '712481',
		来义乡: '712482',
		万峦乡: '712483',
		莰顶乡: '712484',
		新埤乡: '712485',
		南州乡: '712486',
		林边乡: '712487',
		东港镇: '712488',
		琉球乡: '712489',
		佳冬乡: '712490',
		新园乡: '712491',
		枋寮乡: '712492',
		枋山乡: '712493',
		春日乡: '712494',
		狮子乡: '712495',
		车城乡: '712496',
		牡丹乡: '712497',
		恒春镇: '712498',
		满州乡: '712499',
		台东市: '712584',
		绿岛乡: '712585',
		兰屿乡: '712586',
		延平乡: '712587',
		卑南乡: '712588',
		鹿野乡: '712589',
		关山镇: '712590',
		海端乡: '712591',
		池上乡: '712592',
		东河乡: '712593',
		成功镇: '712594',
		长滨乡: '712595',
		金峰乡: '712596',
		大武乡: '712597',
		达仁乡: '712598',
		太麻里乡: '712599',
		花莲市: '712686',
		新城乡: '712687',
		太鲁阁: '712688',
		秀林乡: '712689',
		吉安乡: '712690',
		寿丰乡: '712691',
		凤林镇: '712692',
		光复乡: '712693',
		丰滨乡: '712694',
		瑞穗乡: '712695',
		万荣乡: '712696',
		玉里镇: '712697',
		卓溪乡: '712698',
		富里乡: '712699',
		马公市: '712794',
		西屿乡: '712795',
		望安乡: '712796',
		七美乡: '712797',
		白沙乡: '712798',
		湖西乡: '712799',
		南竿乡: '712896',
		北竿乡: '712897',
		东引乡: '712898',
		莒光乡: '712899',
		湾仔区: '810102',
		九龙城区: '810201',
		油尖旺区: '810202',
		深水埗区: '810203',
		黄大仙区: '810204',
		观塘区: '810205',
		大埔区: '810302',
		沙田区: '810303',
		西贡区: '810304',
		元朗区: '810305',
		屯门区: '810306',
		荃湾区: '810307',
		葵青区: '810308',
		离岛区: '810309',
		花地玛堂区: '820102',
		花王堂区: '820103',
		望德堂区: '820104',
		大堂区: '820105',
		风顺堂区: '820106',
		嘉模堂区: '820202',
		路氹填海区: '820203',
		圣方济各堂区: '820204',
	},
};
